<template>
    <div>
        <div class="h-crumbOut">
            <div class="h-crumbs">
                <el-breadcrumb separator="|">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">项目管理</a></el-breadcrumb-item>
                    <el-breadcrumb-item><a href="/">盈利测算</a></el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="h-piece">
            <div class="h-pieceTitle2">
                <h1>项目信息</h1>
            </div>
            <div class="h-pieceCon2">
                <div class="h-formLine h-enter">
                    <el-form :model="ProMain" label-position="right" ref="formLabelAlign" :inline="true"
                             class="demo-ruleForm h-formbLine" :rules="rules">
                        <el-form-item label="项目名称" class="h-elformWrap-2">
                            <el-input v-model="ProMain.projectName" placeholder="" disabled="disabled"></el-input>
                        </el-form-item>

                        <el-form-item label="开标日期" class="h-elformWrap-2" prop="bid">

                            <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择时间"
                                            v-model="ProMain.bid" style="width: 100%;"></el-date-picker>

                        </el-form-item>

                        <el-form-item prop="repairtype" label="保修期" :rules="[
								  { required: true, message: '请选择保修期', trigger: 'change'},
								]" class="h-elformWrap-2">
                            <brselect clearable category="baoxiuqi_cesuan" :v="ProMain.repairtype"
                                      v-model="ProMain.repairtype" @change="repairchangetype"></brselect>
                        </el-form-item>


                        <el-form-item prop="quyu" label="区域" class="h-elformWrap-2">

<!--                            <el-select v-model="ProMain.quyu"-->
<!--                                       filterable-->
<!--                                       placeholder="区域" clearable :disabled="shenpiyemian" @change="quyubianma">-->
<!--                                <el-option-->
<!--                                        v-for="item in quyukexuan"-->
<!--                                        :key="item.value"-->
<!--                                        :label="item.label"-->
<!--                                        :value="item">-->
<!--                                </el-option>-->
<!--                            </el-select>-->

                            <brselect clearable category="haiwaiquyu_cesuan" :v="ProMain.des"
                                      v-model="ProMain.des" @change="quyubianma" :disabled="shenpiyemian" :valuecodedes="true" ></brselect>

                        </el-form-item>


                        <el-form-item prop="fukuanfangshi" label="付款方式" :rules="[
								  { required: true, message: '请选择付款方式', trigger: 'change'},
								]" class="h-elformWrap-2">
                            <brselect clearable category="YLPayTerm_cesuan" :v="ProMain.fukuanfangshi"
                                      v-model="ProMain.fukuanfangshi" @change="fukuanfangshichangetype"></brselect>
                        </el-form-item>

                        <el-form-item label="账期" class="h-elformWrap-2" prop="zhangqi">
                            <dictname category="zhangqi_cesuan" :v="ProMain.zhangqi"
                                      style="display:inline-block;color:#868686;padding-left: 10px;width:100%;border-bottom: 1px solid #dedede;"/>
                        </el-form-item>


                        <el-form-item label="选择特价使用人" class="h-elformWrap-2" style="position:relative"
                                      prop="xuanzhongren">
                            <el-input v-model="ProMain.xuanzhongren" placeholder="请输入" readonly>
                                <!--                                <i-->
                                <!--                                        class="el-icon-search el-input__icon"-->
                                <!--                                        slot="suffix"-->
                                <!--                                        @click="tanchuxuanzeren" >-->
                                <!--                                </i>-->
                            </el-input>
                        </el-form-item>

                        <showxuanzerencesuan
                                :visible.sync="xuanzeren"
                                ddlx="2"
                                v-if="xuanzeren"
                                @choseObj="shiyongrenxuanze"
                                oneflag
                                title="选择经销商"/>


                        <el-form-item class="h-elformWrap-1 ljjrange" label="选择特价有效期" prop="youxiaoqi">
                            <el-col>

                                <!--                                <el-date-picker type="date" placeholder="选择时间" v-model="ProMain.youxiaoqi" value-format="yyyy-MM-dd"></el-date-picker>-->

                                <el-date-picker
                                        v-model="ProMain.youxiaoqi"
                                        type="daterange"
                                        range-separator=" 至 "
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        style="width: 6rem"
                                        value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>

                            </el-col>
                        </el-form-item>

                        <br>

                        <el-form-item
                                v-if="shenpiyijianshow"
                                label="原始版本查看"
                                class="h-elformWrap-2 "
                                prop="xiangmucode"
                        >

                            <el-button type="text" size="small" class="h-tableLink h-btn"
                                       @click="cesuanbanbenchakan">原始版本查看
                            </el-button>

                        </el-form-item>


                        <br>

                        <el-form-item label="驳回审批意见" class="h-elformWrap-2" v-if="shenpiyijianshow">
                            <el-input v-model="ProMain.shenpiyijian" placeholder="" disabled="disabled"></el-input>
                        </el-form-item>

                    </el-form>

                    <!--                    <div class="xia" v-if="!this.shenpiyemian" style="margin-top: 0.1rem;">-->
                    <!--                        <el-button class="h-btn h-bBtn h-bgwhite" @click="qiehuanbanben">切换计算版本</el-button>-->
                    <!--                    </div>-->

                    <div class="anniu" v-if="guanliyuan || caiwu" style="margin-top: 0.3rem;">
                        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"
                                   @click="gongshiduizhaokai">公式对照表
                        </el-button>
                        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"
                                   @click="xianshijisuanguocheng">显示计算过程
                        </el-button>
                        <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default"
                                   @click="xiangxixinxixianshi">显示详细计算信息
                        </el-button>
                        <el-button class="el-button h-btn h-bBtn h-bgred el-button--default" @click="kankanyichang">
                            异常信息
                        </el-button>
                    </div>

                </div>
            </div>
        </div>
        <div class="h-table ljjtableentersix">
            <el-table
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    @cell-dblclick="dblclick"
                    :row-style="cellstyle"
                    border
					max-height="500"
                    style="width: 100%; margin-top: 20px"
                    :row-class-name="tableRowClassName"
            >
                <el-table-column
                        prop="message"
                        label="分类"
                        width="140"
						:show-overflow-tooltip="true"
                        fixed
                >
                </el-table-column>
                <el-table-column
                        prop="coding"
                        label="科目"
                        :show-overflow-tooltip="true"
                        width="190"
						fixed
                >
                </el-table-column>
                <el-table-column
                        prop="shuoming"
                        label="说明"
                        :show-overflow-tooltip="true"
                        min-width="200"

                >
                    <template slot-scope="scope">

                        <div v-if="scope.$index ==28" @click="showlvaction">
                            <div>{{scope.row.shuoming}}</div>
                            <div style="font-size: 20%">点击手动添加售后换机率</div>
                        </div>

                        <div v-else>{{scope.row.shuoming}}</div>

                    </template>


                </el-table-column>

                <el-table-column
                        prop="hejiL"
						:show-overflow-tooltip="true"
                        width="140"
                        label="合计-率">
                    <template slot-scope="scope">
                        <div v-if="scope.$index == 5
                        ||scope.$index == 15
                        ||scope.$index == 16
                        ||scope.$index == 17
                        ||scope.$index == 19
                        ||scope.$index == 20
                        ||scope.$index == 21
                        ||scope.$index == 22
                        ||scope.$index == 23
                        || scope.$index == 24
                        ||scope.$index == 25
                        || scope.$index == 26
                        || scope.$index == 27
                        || scope.$index == 28
                        || scope.$index == 29
                        || scope.$index == 30
                        || scope.$index == 31
                        || scope.$index == 32
                        || scope.$index == 33
                        || scope.$index == 34
                        || scope.$index == 35
                        || scope.$index == 36
                        || scope.$index == 37
                        || scope.$index == 38
                        || scope.$index == 39
                        || scope.$index == 40
                        || scope.$index == 41
                        || scope.$index == 42
                        || scope.$index == 43
                        || scope.$index == 44
                        || scope.$index == 45
						|| scope.$index == 46
						|| scope.$index > 46"
                             :title="scope.row.hejiL">{{new big(Number(scope.row.hejiL).toFixed(2)).times('100') + '%'}}
                        </div>
                        <div v-else>{{scope.row.hejiL}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="hejiE"
						:show-overflow-tooltip="true"
                        width="140"
                        label="合计-额">
                    <template slot-scope="scope">
                        <div v-if="scope.$index==5||scope.$index==21||scope.$index==40||scope.$index==46||scope.$index>46"
                             :title="scope.row.hejiE">{{new big(Number(scope.row.hejiE).toFixed(2)).times('100') + '%'}}
                        </div>
                        <div v-else-if="scope.$index==13" :title="scope.row.hejiE">{{Number(scope.row.hejiE).toFixed(4)}}
                        </div>
                        <div v-else-if="scope.$index==3||scope.$index==2||scope.$index==1||scope.$index==0">
                            {{scope.row.hejiE}}
                        </div>
                        <div v-else :title="scope.row.hejiE">{{Number(scope.row.hejiE).toFixed(2)}}
                        </div>
                        <!-- <div v-if="scope.$index>3" :title="scope.row.hejiE">{{Math.round(scope.row.hejiE * 100) /
                            100}}
                        </div> -->
                    </template>
                </el-table-column>

                <el-table-column
						min-width="150"
                        :prop="item.prop"
                        :label="item.label" v-for="item in columndata" :key='item.label'>


                    <template slot-scope="scope">

                        <div v-if="shenpiyemian">

                            <!-- <el-input
                                    v-if="scope.$index != 0 && scope.$index != 1 && scope.$index != 2 && scope.$index != 3"
                                    v-model="scope.row[item.prop]"
                                    @blur="caiwugaishula(scope.row,scope.row[item.prop])"
                            ></el-input>


                            <div v-else>{{scope.row[item.prop]}}</div>
 -->
                            <div v-if="scope.$index == 0 || scope.$index == 1 || scope.$index == 2 || scope.$index == 3">
                                {{scope.row[item.prop]}}
                            </div>
                            <div v-else-if=" scope.$index == 14 || scope.$index == 15 || scope.$index == 16 || scope.$index == 17 || scope.$index == 19 || scope.$index == 20 || scope.$index == 21 || scope.$index == 38 || scope.$index == 39 || scope.$index == 40 || scope.$index == 44 || scope.$index == 45 || scope.$index == 46
">{{scope.row[item.prop]?Number(scope.row[item.prop]).toFixed(2):'&nbsp;'}}</div>
                            <el-input class="h-tableInput" v-else-if="scope.row['flags' + item.flagsindex]==true" v-focus
                                      v-model="scope.row[item.prop]"
                                      @blur="caiwugaishula(scope.row,scope.row[item.prop],item.flagsindex)"></el-input>
                            <div style="border:1px solid #DCDFE6;padding: 0.05rem 0;text-align: left;padding-left: 0.1rem;"
                                 v-else :title="scope.row[item.prop]" @click="clickjiage(scope.row,item.flagsindex)">
                                {{scope.row[item.prop]?Number(scope.row[item.prop]).toFixed(2):'&nbsp;'}}
                            </div>

                        </div>

                        <div v-else>

                            <el-input
									class="h-tableInput"
                                    v-if="scope.$index == 7
                                    || scope.$index == 8
                                      || scope.$index == 9
                                      || scope.$index == 10
                                    || (scope.$index ==18 && (scope.row['sunyixianshi' + item.dijige]==true))
                                    || (scope.$index ==22 && (scope.row['sunyixianshi' + item.dijige]==true))
                                    || scope.$index == 31"
                                    v-model="scope.row[item.prop]"


                            ></el-input>


                            <div v-else>
                                <div v-if="scope.$index==5||scope.$index==21||scope.$index==40||scope.$index==46"
                                     :title="scope.row[item.prop]">{{new big(Number(scope.row[item.prop]).toFixed(2)).times('100')+ '%'}}
                                </div>
                                <div v-else-if="scope.$index==13" :title="scope.row[item.prop]">
                                    {{Number(scope.row[item.prop]).toFixed(4)}}
                                </div>
                                <div v-else-if="scope.$index==3||scope.$index==2||scope.$index==1||scope.$index==0">
                                    {{scope.row[item.prop]}}
                                </div>
                                <div v-else :title="scope.row[item.prop]">{{Number(scope.row[item.prop]).toFixed(2)}}
                                </div>
                            </div>

                        </div>

                    </template>

                </el-table-column>


            </el-table>

<!--            <div class="h-tableB h-mrt30" style="height: 1rem;" v-if="!this.shenpiyemian">-->

<!--                <div class="h-pagination2 ">-->
<!--                    <paginationminNosize :page="ajaxRequest" @query="haiwaiquery"/>-->
<!--                </div>-->

<!--            </div>-->

        </div>


        <div style="margin:20px" v-if="xianshinage==0 && (this.caiwuShpFlag || this.guanliyuan || this.caiwu)">
            <div class="yx_progressBar ">
                <div class="yxExtra" style="right: 2.5rem;top:0.4rem">
                    <div style="margin-bottom: 0.2rem;" v-if="!this.shenpiyemian">该申请价格达到盈利目标</div>
                </div>
                <div class="yx_topTip">
                    <div class="leftdes">
                        <span>材料毛利：</span><span class="percent">{{zongmaolilv}}%</span>
                    </div>
                    <div class="leftdes">
                        <span>经营贡献：</span><span class="percent">{{jingyinggongxiangzong|rounding}}</span>
                    </div>

                    <div class="leftdes">
                        <span>经营贡献率：</span><span class="percent">{{this.tableData[40].hejiE*100|rounding}}%</span>
                    </div>

                    <div class="leftdes">
                        <span>利润：</span><span class="percent">{{lirunzong|rounding}}</span>
                    </div>

                    <div class="leftdes">
                        <span>利润率：</span><span class="percent">{{this.tableData[46].hejiE*100|rounding}}%</span>
                    </div>
                </div>

            </div>
        </div>


        <div style="margin:20px" v-else-if="xianshinage==1 && (this.caiwuShpFlag || this.guanliyuan || this.caiwu)">
            <div class="yx_progressBar yx_progressBarAc">
                <div class="yxExtra" style="right: 2.5rem;top:0.4rem">
                    <div style="margin-bottom: 0.2rem;" v-if="!this.shenpiyemian"></div>

                </div>
                <!--                <el-button class="h-btn h-bgblueQ2" @click="tijiaoshenqingtejia"-->
                <!--                           style="position:absolute;top:0.3rem;right: 0.7rem" v-if="!this.shenpiyemian">发起特价申请-->
                <!--                </el-button>-->
                <div class="yx_topTip">
                    <div class="leftdes">
                        <span>材料毛利：</span><span class="percent">{{zongmaolilv}}%</span>
                    </div>
                    <div class="leftdes">
                        <span>经营贡献：</span><span class="percent">{{jingyinggongxiangzong|rounding}}</span>
                    </div>

                    <div class="leftdes">
                        <span>经营贡献率：</span><span class="percent">{{this.tableData[40].hejiE*100|rounding}}%</span>
                    </div>
                    <div class="leftdes">
                        <span>利润：</span><span class="percent">{{lirunzong|rounding}}</span>
                    </div>

                    <div class="leftdes">
                        <span>利润率：</span><span class="percent">{{this.tableData[46].hejiE*100|rounding}}%</span>
                    </div>
                </div>

            </div>
        </div>


        <el-button
                v-if="!caiwugaishutongguo"
                style="margin-left: 20px;"
                size="small" class="h-btn h-bBtn h-bgwhite"
                @click="showhistory = true">
            跟踪审批
        </el-button>

        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>



        <div v-if="!zhidumoshi">

        <div v-if="shenpiyemian">

            <div class="h-table h-mrt30 h-rowBox dddd" style="margin:0.2rem">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1" style="margin-left:0.2rem">审批意见</h1>
                    <el-form :model="yinglishenpi" label-position="right" ref="yinglishenpi" :inline="true"
                             :rules="shenpirules" class="demo-ruleForm h-formbLine">
                        <div class="h-txtLeft">
                            <el-form-item label="审批意见" class="h-elformWrapz-1" prop="shenheyijian"
                                          style="margin-top:0.2rem;margin-left: 0.2rem;">
                                <el-input v-model="yinglishenpi.shenheyijian" placeholder="审批意见"
                                          style="width:4rem"></el-input>
                            </el-form-item>
                            <br>
                        </div>
                    </el-form>
                </div>
            </div>


            <div class="anniu1">
				<el-button style="margin-left: 20px;" size="small" class="h-btn h-bBtn h-bgwhite" @click="caiwuzancunyuanshibanben">
					原始审批版本查看
				</el-button>
				<el-button style="margin-left: 20px;" size="small" class="h-btn h-bBtn h-bgwhite" @click="qiehuanbanbencaiwuzancun">
					查看暂存
				</el-button>
				<el-button class="h-btn h-bBtn zancun"
						   style="background-color:#24b5b8;color:white;border-color:#24b5b8;"
						   @click="shenpijisuan">计算
				</el-button>
				<el-button class="h-btn h-bBtn h-bgblueQ2"
						   @click="xiugaitijiao">
					修改提交通过
				</el-button>
				<el-button class="h-btn h-bBtn" style="background-color:rgb(39, 122, 190);color:white;" @click="caiwuzancun">
					暂存
				</el-button>
				<el-button class="h-btn h-bBtn h-bgwhite" @click="quxiaoanniu">返回</el-button>
				<el-button class="el-button h-btn h-bBtn h-bgred el-button--default"
						   @click="bohuianniu('yinglishenpi')">驳回
				</el-button>
				<el-button v-if="!dangqiancaiwuzancun" class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="tongguoanniu">原版通过
				</el-button>
            </div>

        </div>


        <div class="xia" v-else-if="!shifouzhidu">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="handleDelete">删除版本</el-button>
            <el-button class="h-btn h-bBtn h-bgwhite" @click="fanhuishangye">返回</el-button>
            <el-button class="h-btn h-bBtn zancun" style="background-color:#24b5b8;color:white;border-color:#24b5b8;"
                       @click="haiwaicesuan(0)" v-if="!beibohui">暂存
            </el-button>
            <el-button class="h-btn h-bBtn zancun" style="background-color:#24b5b8;color:white;border-color:#24b5b8;"
                       @click="haiwaicesuan(null)" v-if="!beibohui">计算
            </el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2"
                       @click="haiwaicesuan(1)" v-if="!beibohui">
                确认提交
            </el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2"
                       @click="chongxintijiao" v-if="beibohui">
                重新提交
            </el-button>

        </div>

        </div>


        <!-- 选择测算版本 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="refuseDialog" class="h-dialog2" @close="gettable">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>选择以往测算版本</h1>
                        <p>Selection process</p>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-select v-model="banbenid" placeholder="请选择" style="width:7rem;" @change="fuzhi">
                        <el-option v-for="item in banbenop" :key="item.value"
                                   :label="item.label" :value="item.value">
                        </el-option>

                    </el-select>

                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="refuseDialog=false">确定</el-button>
                    </div>

                </div>


            </div>


        </el-dialog>

        <!-- 选择财务暂存版本 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="showcaiwuzancun" class="h-dialog2" @close="gettablecaiwuzancun">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>选择财务暂存版本</h1>
                        <p>Selection process</p>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-select v-model="banbenid" placeholder="请选择" style="width:7rem;" @change="fuzhi">
                        <el-option v-for="item in banbenop" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>

                    </el-select>

                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="showcaiwuzancun=false">确定</el-button>
                    </div>

                </div>

            </div>


        </el-dialog>


        <el-dialog :visible.sync="showlv" class="h-dialog2" :show-close="true" :close-on-click-modal="false">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>添加售后换机率</h1>
                    </div>
                </div>
            </div>


            <div class="h-formLines">
                <div style="padding: 40px;">

                    <el-select v-model="huanjilv" placeholder="请选择" style="width:7rem;" @change="huanjilvxuanze">
                        <el-option v-for="item in showlvop" :key="item.value"
                                   :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>

                    <el-input v-model="shuruhuanjilv" v-if="keyishuru" placeholder="请输入.xxx"
                              @blur="dongtaishezhi"
                    ></el-input>

                    <div style="text-align: right;margin-top: 5%">
                        <el-button class="h-btn h-formBtn" style="" @click="shezhihuanjilv">确定</el-button>
                    </div>

                </div>

            </div>

        </el-dialog>


        <!-- 计算过程 -->
        <el-dialog :visible.sync="jisuanjiluxianshi" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="jisuanjilujieguostr" readonly rows="50"></el-input>


                <!--                <el-table-->
                <!--                        :data="jisuanjilujieguo"-->
                <!--                        @cell-dblclick="dblclick"-->
                <!--                        border-->
                <!--                        style="font-size: x-small;white-space: pre-wrap;"-->
                <!--                >-->

                <!--                    <el-table-column-->
                <!--                            prop="xuhao"-->
                <!--                            width="200"-->
                <!--                            label="项"-->

                <!--                    >-->
                <!--                    </el-table-column>-->

                <!--                    <el-table-column-->
                <!--                            prop="xinxi"-->
                <!--                            width="1000"-->
                <!--                            label="信息"-->

                <!--                    >-->
                <!--                    </el-table-column>-->


                <!--                </el-table>-->

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="jisuanjiluxianshi=false">确定</el-button>
            </div>


        </el-dialog>


        <!-- 计算详细记录 -->
        <el-dialog :visible.sync="xiangxijilu" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="xiangxijilujieguo" readonly rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="xiangxijilu=false">确定</el-button>
            </div>


        </el-dialog>


        <!-- 公式对照表 -->
        <el-dialog :visible.sync="gongshiduizhao" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="gongshiduizhaobiao" readonly rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="gongshiduizhao=false">确定</el-button>
            </div>


        </el-dialog>

        <!-- 异常信息 -->
        <el-dialog :visible.sync="jianchayichang" :show-close="true" :close-on-click-modal="false">

            <div>

                <el-input type="textarea" v-model="yichangxinxi" readonly
                          rows="50"></el-input>

            </div>

            <div style="text-align: right;margin-top: 5%">
                <el-button class="h-btn h-formBtn" style="" @click="jianchayichang=false">确定</el-button>
            </div>


        </el-dialog>


    </div>
</template>


<script>
    import showxuanzerencesuan from '../../../components/dialog/selectshdfcesuan'
    import ss from '../../../api/SystemService'
    import big from 'big.js'

    export default {

        components: {
            showxuanzerencesuan
        },

        data() {

            return {

                zancunid:'',

                dangqiancaiwuzancun:false,

                showcaiwuzancun:false,

                zonggeshu:0,

                caiwu:false,

                //只读版本id
                cesuanid:'',

                //财务改数直接通过的没有审批流
                caiwugaishutongguo:false,

                //只读模式
                zhidumoshi:false,

                quyubianma2:'',

                shifouzhidu: false,

                haiwaiquyucesuan: [],

                // quyukexuan: [],

                duoxinghaocesuan: [],

                jisuancishu: 0,

                baocuntable: [],

                beigaishude: [],

                zhiqianbanben: {},

                meiyoubanben: false,

                shiyongrenuser: null,

                yichangxinxi: '',

                jianchayichang: false,

                gongshiduizhaobiao: '',

                gongshiduizhao: false,

                xiangxijilu: false,

                xiangxijilujieguo: '',

                jisuanjilujieguostr: '',

                cesuanbiaoshi: [],

                jisuanjilujieguo: [],

                jisuanjiluxianshi: false,

                //管理员
                guanliyuan: false,

                shifouxiaoshoujingli: false,

                xuanzeren: false,

                //被驳回
                beibohui: false,


                yinglishenpi: {

                    shenheyijian: '',

                },

                shenpirules: {
                    shenheyijian: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                },


                //审批页面
                shenpiyemian: false,

                chushihuabiao: false,

                keyishuru: false,

                huanjilv: '',

                shuruhuanjilv: '',


                showlv: false,


                showlvop: [],


                //海外项目产品id数组
                haiwaixiangmuchanpin: [],


                //驳回版本id
                delrversion: null,

                shenpiyijianshow: false,

                showhistory: false,

                instid: null,


                //前页项目
                qianyexiangmu: {},

                //选择项目参数
                rateFormulaRenewXiangmucanshu: null,

                //计算返回版本id
                fanhuibanbenid: null,

                //计算版本
                rversion: null,
				
				baocunbianliangb:'',


                guochenglist: [],

                caiwuzancunlist:[],

                xuanzhongbanben: [],

                refuseDialog: false,


                banbenid: '',


                banbenop: [],


                //计算过程对象
                rateFormulaRenewVer: {},


                //显示哪个利率总计框
                xianshinage: 9,

                jingyinggongxiangzong: 0,

                lirunzong: 0,

                zongmaolilvbiao: 0,

                zongmaolilv: 0,


                // 进度
                progressBar: [
                    {name: "王振刚", ifBlue: 1, ifing: 0},
                    {name: "总部管理员", ifBlue: 1, ifing: 0},
                    {name: "财务经理", ifBlue: 2, ifing: 0},
                    {name: "待审核", ifBlue: 0, ifing: 0},
                ],

                list: [
                    {
                        title: '提交人:王振刚',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '总部管理员',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '待审核',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    },
                    {
                        title: '财务经理',
                        isactive: 0,
                        time: '2019/09/10 18:00:00',
                    }
                ],


                //物料号
                marcode: '',


                rules: {


                    zhangqi: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    fukuanfangshi: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    bid: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    repairtype: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],

                    // xuanzhongren: [
                    //     { required: true, message: '不能为空', trigger: 'blur' },
                    //
                    // ],
                    youxiaoqi: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                    ],


                },


                ajaxRequest: {

                    pageSize: 15,
                    pageNo: 1,
                    total: 0,
                    fileName: null,

                },


                //项目产品list
                xiangmuchanpinlist: [],


                q: {

                    pageSize: 5,
                    pageNo: 1,
                    total: 0,

                },

                //全合计金额map
                allratemap: {},


                //是否首次交互
                shoucijiaohu: true,

                //申请单价含税 组
                shenqingdanjiaop: [],

                //附加成本 组
                fujiachengbenop: [],


                //附加成本
                fujiachengben: "",

                //申请单价含税
                shenqingdanjia: '',

                //项目编号
                proid: '',

                //质保选中值
                repairtype: null,


                //
                columndata: [],

                //列表翻页参数
                value3: 0,

                //上部列表信息
                ProMain: {

                    //选中人
                    xuanzhongren: '',
                    //使用人
                    shiyongren: '',

                    //有效期
                    youxiaoqi: ['', ''],

                    repairtype: '',

                    quyu: '',

                    des: '',

                    fukuanfangshi: '',

                    zhangqi: '',

                    //项目名称
                    projectName: '',

                    //投标方式
                    bidway: '',

                    //开标日期
                    bid: null,

                    //预付百分比
                    pdpay: '',

                    //首款百分比
                    fdpay: '',

                    //中款百分比
                    mdpay: '',

                    //尾款百分比
                    ldpay: '',

                    //首款天
                    fdpayday: '',

                    //中款天
                    mdpayday: '',

                    //尾款天
                    ldpayday: '',

                    //项目描述
                    projectDescription: '',

                    //终端成交价
                    zhongduanchengjiaojia: '',

                    //专营商毛利率
                    zhuanyingshangmaolilv: '',

                    //审批意见
                    shenpiyijian: '',

                },


                //当前表信息
                tableData: [],


                //所有查到的计算回调信息
                alllastlist: [],

                caiwuShpFlag:false,
            };
        },

        //加载页面默认执行
        created() {

            this.jiazaigongshibiao();

            //测算标识
            this.cesuanbiaoshi = this.$store.getters.dictlist("cesuanguocheng_cesuan");

            //管理员
            this.guanliyuan = this.$store.getters.hasRole('swyl_admin');

            //财务
            this.caiwu = this.$store.getters.hasRole('swyl_haiwai_caiwu');

            //海外区域
            this.haiwaiquyucesuan = this.$store.getters.dictlist("haiwaiquyu_cesuan");


            //判断目前使用人如果是销售经理，就会默认隐藏表格一部分
            for (var d in this._user.roles) {

                if (this._user.roles[d].id == 'swyl_xiaoshoujl' || this._user.roles[d].id == 'swyl_xiaoshoujl_wx' || this._user.roles[d].id == 'xiaoshoujingli-waixiao') {

                    this.shifouxiaoshoujingli = true;

                }

            }

            //若是有转发信息
            // if (this.$route.query != null) {
            if (JSON.stringify(this.$route.query) != '{}') {

                //若是审批信息
                if (this.$route.query.ywid) {

                    console.log(this.$route.query, '看看审批的对象')

                    //ywid
                    this.ywid = this.$route.query.ywid;

                    //instid
                    this.instid = this.$route.query.instid;

                    //taskid
                    this.taskid = this.$route.query.taskid;

                    //计算版本
                    this.rversion = this.$route.query.ywid;

                    //是审批页面
                    this.shenpiyemian = true;
					

                    //加载对应历史记录版本
                    this.zaijiajisuanjilu(this.$route.query.ywid);

                    //若是普通项目转发
                } else if (this.$route.query.id) {

                    //前页转发
                    this.qianyezhuanfa();

                }

            }


            //特价查看跳转
            if(this.$route.query.chakanshiti && this.$route.query.chakanshiti!=''){

                console.log(this.$route.query.chakanshiti,'this.$route.query.chakanshiti')

                //只读
                this.zhidumoshi = true;

                //计算版本
                this.rversion = this.$route.query.chakanshiti;

                var rversion = {

                    rversion:this.$route.query.chakanshiti

                }

                //找版本判断instid
                ss.FormulaNew.getbanben(rversion).then(rd => {

                    //判断instid
                    this.panduaninstid(rd.obj);

                })

                //加载对应历史记录版本
                this.zaijiajisuanjilu(this.$route.query.chakanshiti);


            }


        },

        mounted() {


        },
        directives: {
            // 注册一个局部的自定义指令 v-focus
            focus: {
                // 指令的定义
                inserted: function (el) {
                    // 聚焦元素
                    el.querySelector('input').focus()
                }
            }
        },
        filters: {
            rounding(value) {
                return value ? value.toFixed(2) : 0;
            }
        },


        watch: {


            showlv(val) {

                if (val == false) {

                    this.huanjilv = '';
                    this.showlvop = [];
                    this.shuruhuanjilv = '';
                    this.keyishuru = false;

                }

            }

        },


        methods: {

            //测算版本查看
            cesuanbanbenchakan() {

                //测算版本有的话
                if(this.cesuanid!=null && this.cesuanid!=''){

                    var rversion = {

                        rversion:this.cesuanid
                    }

                    //查找测算版本
                    ss.FormulaNew.getbanben(rversion).then(rd => {

                        console.log(rd.obj,'测算')

                        //测算
                        this.neiwaixiaopanduan(rd.obj);

                    })

                }

            },

            //测算跳转判断
            neiwaixiaopanduan(q){
                console.log(q, "asdasd????")

                var path = '';

                if (q.neixiaowaixiao == 1 && q.ispro==1) { //外销项目
                    //跳转外销项目
                    path = '/xiangmu/entersix';

                } else if (q.neixiaowaixiao == 1 && q.ispro==0) { //外销工具
                    //跳转外销工具
                    path = '/xiangmu/enterseven';

                }else if (q.neixiaowaixiao == 0) { //内销
                    //跳转内销测算
                    path = '/xiangmu/enterfive';

                } else if (q.neixiaowaixiao == 2) { //租赁
                    //跳转内销测算
                    path = '/rateFormulaZulinshiti';

                }

                var shiti = {
                    chakanshiti:q.rversion
                }

                console.log(shiti,'shitishitishiti')


                let routeData = this.$router.resolve({ path: path, query: shiti });
                window.open(routeData.href, '_blank');


            },


            //查找财务单保存
            chazhaocaiwudanbaocun(q){

                ss.FormulaNew.finddanbaocun(q).then(rd => {

                    console.log(rd,'rdrdrdrdoooooo')

                    if(JSON.stringify(rd.obj) != '{}' && rd.obj.rversion!=null && rd.obj.rversion!=''){

                        this.cesuanid = rd.obj.rversion;

                    }

                })


            },


            //判断instid
            panduaninstid(re){

                //存在审批instid
                if(re.instid!=null){

                    this.instid = re.instid
                    //判断财务是否审批通过
                    ss.FormulaNew.searchCaiwuShpStatus(data).then(rd => {
                        if(rd.msg){
                            this.caiwuShpFlag = true;
                        }
                    })
                    //不存在
                }else{

                    //如果已经通过，说明是财务修改直接通过的
                    if(re.status==2 && re.xid!=null){

                        this.caiwugaishutongguo = true;
                        this.caiwuShpFlag = true;
                    }

                }

            },

            quyubianma(v){

                console.log(v)

                //区域码
                this.ProMain.quyu = v.code;

                //区域码xxxx
                this.quyubianma2 = v.des;

                console.log(this.ProMain.quyu,'this.ProMain.quyu')
                console.log(this.quyubianma2,'quyubianma2')

            },

            qianyezhuanfa() {

                //转发的项目信息
                this.qianyexiangmu = this.$route.query;

                //项目名
                this.ProMain.projectName = this.$route.query.projectName;

                console.log(this.$route.query, '项目转发')

                //加载项目产品初始化表格的参数项目id
                this.ajaxRequest.fileName = this.$route.query.id;

                //海外测算参数项目id
                this.proid = this.$route.query.id;

                //找项目使用人
                this.zhaodaoshiyongren(this.$route.query.id);

                //查找版本
                this.chazhaocesuan(this.$route.query.id);

                //查找计算记录
                this.chazhaojisuanguocheng(this.$route.query.id);

            },

            clickjiage(item, index) {
                console.log(item)
                item['flags' + index] = true
            },

            //查找损益
            quchazhaosunyi() {

                ss.FormulaHaiwai.chazhaosunyi(this.duoxinghaocesuan).then(rd => {

                    console.log(rd, '到底null')

                    for (var s in rd.obj) {

                        for (var ss in rd.obj[s]) {

                            //如果后台损益没有值(返回'null'字符串)，就让选填的部分变为可以选填
                            if (rd.obj[s][ss] == 'null') {

                                for (var c = 0; c < this.duoxinghaocesuan.length; c++) {

                                    if (this.tableData[0]['xinghao' + (parseInt(c) + 1)] == s) {


                                        for (var d in this.tableData) {

                                            if (this.tableData[d].canshuxulie == ss) {

                                                switch (ss) {

                                                    case 'w21':


                                                        this.tableData[d]['sunyixianshi' + (parseInt(c) + 1)] = true;


                                                        // this.tableData[14]['sunyixianshi'+(parseInt(c)+1)] = true;
                                                        break;
                                                    case 'w25':


                                                        this.tableData[d]['sunyixianshi' + (parseInt(c) + 1)] = true;


                                                        // this.tableData[18]['sunyixianshi'+(parseInt(c)+1)] = true;
                                                        break;

                                                }


                                            }


                                            if (this.tableData[d].hejilvxulie == ss) {

                                                switch (ss) {

                                                    case 'u31':

                                                        this.tableData[d]['sunyixianshi' + (parseInt(c) + 1)] = true;


                                                        // this.tableData[24]['sunyixianshi'+(parseInt(c)+1)] = true;
                                                        break;

                                                }

                                            }

                                        }


                                    }

                                }

                            }

                        }

                    }


                })

            },

            //审批计算
            shenpijisuan() {

                this.jisuancishu++;

                console.log(this.jisuancishu, 'this.jisuancishu')

                this.haiwaicesuan(null);

            },


            chazhaocesuan(q) {

                if (q != null && q != '') {

                    var pid = {

                        proid: q,
                        neixiaowaixiao: 1,

                    }

                    ss.FormulaNew.findguocheng(pid).then(rd => {

                        console.log(rd, 'a')


                        if (JSON.stringify(rd.obj) == '{}') {

                            this.meiyoubanben = true;


                        } else {

                            this.meiyoubanben = false;

                            this.zhiqianbanben = rd.obj;

                        }


                    })

                } else {

                    this.$msg.msge("缺少项目id")

                }

            },


            //财务改数提交
            xiugaitijiao() {

                this.tijiaoagain(13);

            },


            caiwugaishula(row, zhi, index) {
                row['flags' + index] = false;
                console.log(row, zhi)

                for (var c = 1; c < 16; c++) {

                    if (row.canshuxulie != null && row.canshuxulie != '' && row['xinghao' + c] != null && row['xinghao' + c] != '' && row['xinghao' + c] == zhi) {


                        console.log(this.baocuntable, 'baocuntable');

                        for (var d in this.baocuntable) {

                            if (this.baocuntable[d].canshuxulie == row.canshuxulie && this.baocuntable[d]['xinghao' + c] != zhi) {

                                row['shifougaishu' + c] = true;

                                this.beigaishude.push({

                                    c: c,
                                    xinghaoji: "shifougaishu" + c,
                                    flag: true,
                                    canshuxulie: row.canshuxulie,

                                })

                            } else if (this.baocuntable[d].canshuxulie == row.canshuxulie && this.baocuntable[d]['xinghao' + c] == zhi) {

                                row['shifougaishu' + c] = false;

                                for (var f in this.beigaishude) {

                                    if (this.beigaishude[f].canshuxulie == row.canshuxulie && this.beigaishude[f].c == c) {

                                        this.beigaishude[f].flag = false;

                                    }

                                }

                            }

                        }

                    }

                }

                console.log(this.beigaishude, 'this.beigaishude')

            },

            //找项目使用人
            zhaodaoshiyongren(q) {

                ss.FormulaNew.proMainselectById(q).then(rd => {

                    console.log(rd, 'rd')

                    if (rd.obj == null || rd.obj.usercode == null) {

                        this.$msg.msge("该项目信息缺少项目使用人")

                        this.$router.push("/xiangmu/pm")

                    }

                    this.shiyongrenuser = rd.obj;

                    this.ProMain.xuanzhongren = rd.obj.username;

                    this.ProMain.shiyongren = rd.obj.usercode;

                    // this.jiazaiquyuxuanze();


                })

            },

            // //加载区域选择
            // jiazaiquyuxuanze() {
            //
            //     this.quyukexuan = this.haiwaiquyucesuan;

                // this.quyukexuan = [];
                //
                // var quyu = q.split(",");
                //
                // for (var s in this.haiwaiquyucesuan) {
                //
                //     if (quyu.length > 1) {
                //
                //         for (var f in quyu) {
                //
                //             if (this.haiwaiquyucesuan[s].des == quyu[f]) {
                //
                //                 this.quyukexuan.push({
                //
                //                     value: this.haiwaiquyucesuan[s].code,
                //                     label: this.haiwaiquyucesuan[s].name,
                //                     des: this.haiwaiquyucesuan[s].des,
                //                 })
                //
                //             }
                //
                //         }
                //
                //     } else {
                //
                //         if (this.haiwaiquyucesuan[s].des == q) {
                //
                //             this.quyukexuan.push({
                //
                //                 value: this.haiwaiquyucesuan[s].code,
                //                 label: this.haiwaiquyucesuan[s].name,
                //                 des: this.haiwaiquyucesuan[s].des,
                //
                //             })
                //
                //         }
                //
                //     }
                //
                //
                // }

            // },

            kankanyichang() {

                this.jianchayichang = true;

            },

            jiazaijieguoxinxi(rd) {

                this.jisuanjilujieguo = [];
                this.jisuanjilujieguostr = '';
                this.xiangxijilujieguo = '';

                this.yichangxinxi = '';


                for (var c in rd.fanhuixinximap) {

                    this.jisuanjilujieguo.push({

                        xuhao: c.split(":")[0],
                        xinxi: c.split(":")[1]

                    })


                    for (var cc in rd.fanhuixinximap[c]) {


                        if (rd.fanhuixinximap[c][cc].search(",") != -1) {

                            for (var f in this.cesuanbiaoshi) {

                                if (this.cesuanbiaoshi[f].code == (rd.fanhuixinximap[c][cc].split(",")[0].split(":")[1].trim())) {

                                    this.jisuanjilujieguo.push({

                                        xuhao: this.cesuanbiaoshi[f].name,
                                        xinxi: rd.fanhuixinximap[c][cc]

                                    })

                                    this.jisuanjilujieguostr += ("项: " + this.cesuanbiaoshi[f].name + " 信息: " + rd.fanhuixinximap[c][cc] + (this.cesuanbiaoshi[f].des != null ? (" 公式: " + this.cesuanbiaoshi[f].des) : '') + '\n');

                                }

                            }

                        } else {

                            this.jisuanjilujieguostr += (rd.fanhuixinximap[c][cc] + '\n');

                        }


                    }

                }


                for (var c in rd.jisuanjilu) {

                    this.xiangxijilujieguo += (c + rd.jisuanjilu[c] + '\n');

                }

                this.yichangxinxi = rd.tishixinxi;

            },


            jiazaigongshibiao() {

                ss.FormulaNew.gongshibiaolist().then(rd1 => {

                    this.gongshiduizhaobiao = '';

                    for (var c in rd1) {

                        if (rd1[c].type == 'w' || rd1[c].type == 'u') {

                            this.gongshiduizhaobiao += ("公式名: " + rd1[c].proName + (rd1[c].modelName != null && rd1[c].modelName != '' ? ("/" + rd1[c].modelName) : '') + (rd1[c].ratetext != null && rd1[c].ratetext != '' ? (" || 公式信息: " + rd1[c].ratetext) : "") + " || 公式编号: " + rd1[c].formulanum + (rd1[c].formula != null && rd1[c].formula != '' ? (" || 公式: " + rd1[c].formula) : '') + '\n' + '\n');

                        }

                    }

                })


            },

            gongshiduizhaokai() {

                this.gongshiduizhao = true;

            },

            xiangxixinxixianshi() {

                this.xiangxijilu = true;

            },


            xianshijisuanguocheng() {

                this.jisuanjiluxianshi = true;

            },

            panduanxiaoshu() {

                var d = true;


                if (this.shuruhuanjilv && ((parseFloat(this.shuruhuanjilv) != 0 && (/^0.\d+$/.test(this.shuruhuanjilv) == false)) || (parseFloat(this.shuruhuanjilv) != 0 && parseFloat(this.shuruhuanjilv) > 1))) {

                    this.$msg.msge("百分比请输入小于1的小数")

                    d = false;

                } else {

                    d = true;

                }

                return d;

            },

            tableRowClassName(row, index) {

                //若是销售经理
                if (this.shifouxiaoshoujingli) {

                    if (
                        row.rowIndex != 0 &&
                        row.rowIndex != 1 &&
                        row.rowIndex != 2 &&
                        row.rowIndex != 3 &&
                        row.rowIndex != 4 &&
                        row.rowIndex != 6 &&
                        row.rowIndex != 7 &&
                        row.rowIndex != 8 &&
                        row.rowIndex != 9 &&
                        row.rowIndex != 10 &&
                        row.rowIndex != 11 &&
                        row.rowIndex != 12 &&
                        row.rowIndex != 13 &&
                        row.rowIndex != 14 &&
                        row.rowIndex != 23 &&
                        row.rowIndex != 24 &&
                        row.rowIndex != 25 &&
                        row.rowIndex != 28 &&
                        row.rowIndex != 29 &&
                        row.rowIndex != 31
                    ) {
                        return 'hidden-row';
                    }
                    return '';
                }

            },

            tanchuxuanzeren() {
                this.xuanzeren = true;
                // dialogFormVisible
            },

            //选择使用人
            shiyongrenxuanze(val) {
                console.log(val, '+++使用人')
                this.xuanzeren = false;
                this.ProMain.xuanzhongren = val.username;
                this.ProMain.shiyongren = val.usercode;

            },


            //重新提交被驳回的
            chongxintijiao() {

                if (!(this.ProMain.quyu && this.ProMain.zhangqi && this.ProMain.xuanzhongren && this.ProMain.youxiaoqi && this.ProMain.youxiaoqi[0] && this.ProMain.youxiaoqi[1])) {

                    this.$msg.msge("请先填写完整信息")

                } else {

                    this.quchongxintijiao()

                }


            },


            //重新提交
            quchongxintijiao() {

                this.tijiaoagain(3);

            },


            //财务暂存
            caiwuzancun(){

                var entity = this.gouzaocesuancanshu(19);

                entity.rversion = this.rversion;

                //提交
                ss.FormulaHaiwai.getbyhaiwaixiangmu(entity).then(rd => {

                    this.$msg.msgs("暂存成功");

                    console.log(rd,'暂存信息')

                })

            },



            //单保存审批填写信息
            danbaocunshenpi(){

                this.tijiaoagain(15);

            },


            //再次提交
            tijiaoagain(q) {

                var entity = this.gouzaocesuancanshu(q);

                entity.rversion = this.rversion;
				
				this.baocunbianliangb = this.rversion;


                ss.FormulaHaiwai.getbyhaiwaixiangmu(entity).then(rd => {

                    //成功
                    if (rd.f == true && q!=15) {

                        var c = {

                            rversion: this.rversion,

                        }

                        //删除版本
                        ss.FormulaHaiwai.luojishanchubanben(c).then(rd => {

                            //跳转
                            this.shenpitiaozhuan();

                        })

                    }
					
					//如果是驳回先保存成功的
					if(rd.f == true && q==15){
						
						this.overshenpi(this.getshenpientity(1),1);
						
					}
					

                })


            },


            //驳回按钮
            bohuianniu(formname) {

                this.$refs[formname].validate((valid) => {
                    if (valid) {

                        //先保存一个
                        this.danbaocunshenpi();

                        

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });


            },

            //通过按钮
            tongguoanniu() {

                this.overshenpi(this.getshenpientity(2),2);

            },


            //去审批
            overshenpi(q,n) {

                ss.FormulaNew.overhaiwaiyinglishenpi(q).then(rd => {

                    if (rd.f == true) {

                        ss.FormulaNew.haiwaidangengxin(rd.obj).then(rd => {

                            if (rd.f == true) {
								
								//驳回完事了
								if(n==1){
									
									console.log("开始进入驳回完事")
									
									var rversion = {
										
										rversion:this.baocunbianliangb,
										
									}
									
									ss.FormulaNew.fanzhuanop(rversion).then(rd => {
										
										//跳转待办
										this.shenpitiaozhuan();
										
									})
									
								}else{
									
									//跳转待办
									this.shenpitiaozhuan();
									
								}
								
                                

                            }

                        })


                    }

                })

            },


            //审批实体
            getshenpientity(q) {

                var shenPiEntity = {

                    yewuzhujian: this.rversion,//业务主键

                    taskid: this.taskid,//页面拿到的taskid

                    optflag: q == 2 ? '通过' : "驳回",

                    msg: this.yinglishenpi.shenheyijian,//  页面填写的审核意见

                    tongguoorbohui: q,// 通过还是驳回的flag  1驳回  2通过

                    jiediantiaojianming: 'tongguoorbohui',//通过还是驳回的节点条件名字

                    instid: this.instid,//审批版本id

                }

                return shenPiEntity;

            },


            //跳转待办
            shenpitiaozhuan() {

                this.$msg.alerts("提交成功！", () => {
                    //刷新右上角的代办个数
                    this.$store.dispatch("searchTasktotal")
                    //跳转回系统的代办列表
                    this.$router.push({path: '/personal/dealCenter'})
                })

            },


            cellstyle(value) {

                if (value.rowIndex == 7 || value.rowIndex == 8
                    || value.rowIndex == 9
                    || value.rowIndex == 10 || value.rowIndex == 18 || value.rowIndex == 22 || value.rowIndex == 31) {

                    return 'color: red;'

                }


            },


            huanjilvxuanze(value) {

                console.log(value, '看看选中的多少')

                this.shuruhuanjilv = this.tableData[28]['u31' + (value)];

                this.keyishuru = true;

            },


            dongtaishezhi() {

                console.log(this.huanjilv, "选的哪个")

                console.log(this.shuruhuanjilv, "换机率")

                if (this.shuruhuanjilv) {

                    var d = this.panduanxiaoshu();

                    if (d) {

                        this.tableData[28]['u31' + (this.huanjilv)] = this.shuruhuanjilv;

                    }

                }

            },


            shezhihuanjilv() {

                console.log(this.huanjilv, "选的哪个")

                console.log(this.shuruhuanjilv, "换机率")

                if (this.shuruhuanjilv) {

                    var d = this.panduanxiaoshu();

                    if (d) {

                        this.tableData[28]['u31' + (this.huanjilv)] = this.shuruhuanjilv;

                    }


                }

                this.showlv = false;

            },


            showlvaction() {


                for (var s = 0; s < 15; s++) {

                    //如果存在型号
                    if (this.tableData[0]['xinghao' + (s + 1)] != null && this.tableData[0]['xinghao' + (s + 1)] != '') {

                        this.showlvop.push({

                            label: "型号:" + this.tableData[0]['xinghao' + (s + 1)],
                            value: s + 1,

                        });

                    }


                }


                this.showlv = true;

            },


            //构造计算参数
            gouzaocesuancanshu(q) {

                //构造计算参数
                var entity = {
                    savestatus: q,
                    jsb: null,
                };

                var jsb = [];

                for (var s = 0; s < this.haiwaixiangmuchanpin.length; s++) {

                    //必须是有实际产品id才构造参数
                    if (this.haiwaixiangmuchanpin[s] != null && this.haiwaixiangmuchanpin[s] != '') {

                        jsb.push({

                            "shiyongren": this.ProMain.shiyongren == null || this.ProMain.shiyongren == '0' ? '' : this.ProMain.shiyongren,//使用人usercode

                            "youxiaoqistart": this.ProMain.youxiaoqi == null ? null : this.ProMain.youxiaoqi == '0' ? '' : this.ProMain.youxiaoqi[0] == null ? null : this.ProMain.youxiaoqi[0] == '0' ? '' : this.$util.riQi(this.ProMain.youxiaoqi[0]) + "",//特价有效期
                            "validity": this.ProMain.youxiaoqi == null ? null : this.ProMain.youxiaoqi == '0' ? '' : this.ProMain.youxiaoqi[1] == null ? null : this.ProMain.youxiaoqi[1] == '0' ? '' : this.$util.riQi(this.ProMain.youxiaoqi[1]) + "",//特价有效期

                            "w2": this.ProMain.quyu == null || this.ProMain.quyu == '0' ? '' : this.ProMain.quyu,//区域
                            "quyubianma2":this.quyubianma2 == null || this.quyubianma2  == '0' ? '':this.quyubianma2,//定价区域编码

                            "xuanzhongren": this.ProMain.xuanzhongren == null || this.ProMain.shiyongren == '0' ? '' : this.ProMain.xuanzhongren,//使用人username

                            "w26": this.tableData[23]['xinghao' + (s + 1)] != null && this.tableData[23]['xinghao' + (s + 1)] != '' ? this.tableData[23]['xinghao' + (s + 1)] : '0',//海运费

                            "u1": this.proid,//项目id
                            "w3": this.ProMain.bid,//开标日期
                            "w4": this.ProMain.fukuanfangshi,//付款方式
                            "w5": this.ProMain.zhangqi,//账期
                            "w6": this.ProMain.repairtype,//保修期
                            "u2": this.haiwaixiangmuchanpin[s],//项目产品id
                            "u31": this.tableData[28]['u31' + (s + 1)] != null && this.tableData[28]['u31' + (s + 1)] != '' ? this.tableData[28]['u31' + (s + 1)] : '0',//售后换机率
                            "w14": this.tableData[7]['xinghao' + (s + 1)] != null && this.tableData[7]['xinghao' + (s + 1)] != '' ? this.tableData[7]['xinghao' + (s + 1)] : '0',//申请单价$
                            "w21": this.tableData[18]['xinghao' + (s + 1)] != null && this.tableData[18]['xinghao' + (s + 1)] != '' ? this.tableData[18]['xinghao' + (s + 1)] : '0',//毛利--单台成本
                            "w25": this.tableData[22]['xinghao' + (s + 1)] != null && this.tableData[22]['xinghao' + (s + 1)] != '' ? this.tableData[22]['xinghao' + (s + 1)] : '0',//直接费用--制造费用
                            "w27": this.tableData[24]['xinghao' + (s + 1)] != null && this.tableData[24]['xinghao' + (s + 1)] != '' ? this.tableData[24]['xinghao' + (s + 1)] : '0',//保险费
                            "w32": this.tableData[29]['xinghao' + (s + 1)] != null && this.tableData[29]['xinghao' + (s + 1)] != '' ? this.tableData[29]['xinghao' + (s + 1)] : '0',//佣金
                            "w34": this.tableData[31]['xinghao' + (s + 1)] != null && this.tableData[31]['xinghao' + (s + 1)] != '' ? this.tableData[31]['xinghao' + (s + 1)] : '0',//中标服务费

                            "p1": this.tableData[8]['xinghao' + (s + 1)] != null && this.tableData[8]['xinghao' + (s + 1)] != '' ? this.tableData[8]['xinghao' + (s + 1)] : '0',//运费单台

                            "p2": this.tableData[9]['xinghao' + (s + 1)] != null && this.tableData[9]['xinghao' + (s + 1)] != '' ? this.tableData[9]['xinghao' + (s + 1)] : '0',//保费单台

                            "p3": this.tableData[10]['xinghao' + (s + 1)] != null && this.tableData[10]['xinghao' + (s + 1)] != '' ? this.tableData[10]['xinghao' + (s + 1)] : '0',//佣金单台


                            "shifousuibiangai": this.shenpiyemian == true ? "1" : "0",//是不是审批页面(随便改数)，是1  否0

                            //----------------------财务随便改数的----------------------
                            "suibiangai": {

                                "p4":this.tableData[11]['shifougaishu' + (s + 1)] == true ? (this.tableData[11]['xinghao' + (s + 1)] != null && this.tableData[11]['xinghao' + (s + 1)] != '' ? this.tableData[11]['xinghao' + (s + 1)] : '0') : 'no',//单台售价

                                "w11": this.tableData[4]['shifougaishu' + (s + 1)] == true ? (this.tableData[4]['xinghao' + (s + 1)] != null && this.tableData[4]['xinghao' + (s + 1)] != '' ? this.tableData[4]['xinghao' + (s + 1)] : '0') : 'no',//单台一级供价
                                "w12": this.tableData[5]['shifougaishu' + (s + 1)] == true ? (this.tableData[5]['xinghao' + (s + 1)] != null && this.tableData[5]['xinghao' + (s + 1)] != '' ? this.tableData[5]['xinghao' + (s + 1)] : '0') : 'no',//折扣率
                                "w13": this.tableData[6]['shifougaishu' + (s + 1)] == true ? (this.tableData[6]['xinghao' + (s + 1)] != null && this.tableData[6]['xinghao' + (s + 1)] != '' ? this.tableData[6]['xinghao' + (s + 1)] : '0') : 'no',//销量
                                "w15": this.tableData[12]['shifougaishu' + (s + 1)] == true ? (this.tableData[12]['xinghao' + (s + 1)] != null && this.tableData[12]['xinghao' + (s + 1)] != '' ? this.tableData[12]['xinghao' + (s + 1)] : '0') : 'no',//订单金额
                                "w16": this.tableData[13]['shifougaishu' + (s + 1)] == true ? (this.tableData[13]['xinghao' + (s + 1)] != null && this.tableData[13]['xinghao' + (s + 1)] != '' ? this.tableData[13]['xinghao' + (s + 1)] : '0') : 'no',//汇率
                                "w17": this.tableData[14]['shifougaishu' + (s + 1)] == true ? (this.tableData[14]['xinghao' + (s + 1)] != null && this.tableData[14]['xinghao' + (s + 1)] != '' ? this.tableData[14]['xinghao' + (s + 1)] : '0') : 'no',//订单收入
                                "w18": this.tableData[15]['shifougaishu' + (s + 1)] == true ? (this.tableData[15]['xinghao' + (s + 1)] != null && this.tableData[15]['xinghao' + (s + 1)] != '' ? this.tableData[15]['xinghao' + (s + 1)] : '0') : 'no',//材料毛利
                                "w19": this.tableData[16]['shifougaishu' + (s + 1)] == true ? (this.tableData[16]['xinghao' + (s + 1)] != null && this.tableData[16]['xinghao' + (s + 1)] != '' ? this.tableData[16]['xinghao' + (s + 1)] : '0') : 'no',//经营贡献
                                "w20": this.tableData[17]['shifougaishu' + (s + 1)] == true ? (this.tableData[17]['xinghao' + (s + 1)] != null && this.tableData[17]['xinghao' + (s + 1)] != '' ? this.tableData[17]['xinghao' + (s + 1)] : '0') : 'no',//利润
                                "w21": this.tableData[18]['shifougaishu' + (s + 1)] == true ? (this.tableData[18]['xinghao' + (s + 1)] != null && this.tableData[18]['xinghao' + (s + 1)] != '' ? this.tableData[18]['xinghao' + (s + 1)] : '0') : 'no',//单台成本
                                "w22": this.tableData[19]['shifougaishu' + (s + 1)] == true ? (this.tableData[19]['xinghao' + (s + 1)] != null && this.tableData[19]['xinghao' + (s + 1)] != '' ? this.tableData[19]['xinghao' + (s + 1)] : '0') : 'no',//成本合计
                                "w23": this.tableData[20]['shifougaishu' + (s + 1)] == true ? (this.tableData[20]['xinghao' + (s + 1)] != null && this.tableData[20]['xinghao' + (s + 1)] != '' ? this.tableData[20]['xinghao' + (s + 1)] : '0') : 'no',//材料毛利
                                "w24": this.tableData[21]['shifougaishu' + (s + 1)] == true ? (this.tableData[21]['xinghao' + (s + 1)] != null && this.tableData[21]['xinghao' + (s + 1)] != '' ? this.tableData[21]['xinghao' + (s + 1)] : '0') : 'no',//材料毛利率
                                "w25": this.tableData[22]['shifougaishu' + (s + 1)] == true ? (this.tableData[22]['xinghao' + (s + 1)] != null && this.tableData[22]['xinghao' + (s + 1)] != '' ? this.tableData[22]['xinghao' + (s + 1)] : '0') : 'no',//制造费用
                                "w28": this.tableData[25]['shifougaishu' + (s + 1)] == true ? (this.tableData[25]['xinghao' + (s + 1)] != null && this.tableData[25]['xinghao' + (s + 1)] != '' ? this.tableData[25]['xinghao' + (s + 1)] : '0') : 'no',//港杂费
                                "w29": this.tableData[26]['shifougaishu' + (s + 1)] == true ? (this.tableData[26]['xinghao' + (s + 1)] != null && this.tableData[26]['xinghao' + (s + 1)] != '' ? this.tableData[26]['xinghao' + (s + 1)] : '0') : 'no',//商检认证费
                                "w30": this.tableData[27]['shifougaishu' + (s + 1)] == true ? (this.tableData[27]['xinghao' + (s + 1)] != null && this.tableData[27]['xinghao' + (s + 1)] != '' ? this.tableData[27]['xinghao' + (s + 1)] : '0') : 'no',//1%免费备件费
                                "w31": this.tableData[28]['shifougaishu' + (s + 1)] == true ? (this.tableData[28]['xinghao' + (s + 1)] != null && this.tableData[28]['xinghao' + (s + 1)] != '' ? this.tableData[28]['xinghao' + (s + 1)] : '0') : 'no',//售后换机
                                "w33": this.tableData[30]['shifougaishu' + (s + 1)] == true ? (this.tableData[30]['xinghao' + (s + 1)] != null && this.tableData[30]['xinghao' + (s + 1)] != '' ? this.tableData[30]['xinghao' + (s + 1)] : '0') : 'no',//资金成本
                                "w35": this.tableData[32]['shifougaishu' + (s + 1)] == true ? (this.tableData[32]['xinghao' + (s + 1)] != null && this.tableData[32]['xinghao' + (s + 1)] != '' ? this.tableData[32]['xinghao' + (s + 1)] : '0') : 'no',//维修基金
                                "w36": this.tableData[33]['shifougaishu' + (s + 1)] == true ? (this.tableData[33]['xinghao' + (s + 1)] != null && this.tableData[33]['xinghao' + (s + 1)] != '' ? this.tableData[33]['xinghao' + (s + 1)] : '0') : 'no',//其他税费
                                "w37": this.tableData[34]['shifougaishu' + (s + 1)] == true ? (this.tableData[34]['xinghao' + (s + 1)] != null && this.tableData[34]['xinghao' + (s + 1)] != '' ? this.tableData[34]['xinghao' + (s + 1)] : '0') : 'no',//销售人工
                                "w38": this.tableData[35]['shifougaishu' + (s + 1)] == true ? (this.tableData[35]['xinghao' + (s + 1)] != null && this.tableData[35]['xinghao' + (s + 1)] != '' ? this.tableData[35]['xinghao' + (s + 1)] : '0') : 'no',//销售组织运营
                                "w39": this.tableData[36]['shifougaishu' + (s + 1)] == true ? (this.tableData[36]['xinghao' + (s + 1)] != null && this.tableData[36]['xinghao' + (s + 1)] != '' ? this.tableData[36]['xinghao' + (s + 1)] : '0') : 'no',//研发人工
                                "w40": this.tableData[37]['shifougaishu' + (s + 1)] == true ? (this.tableData[37]['xinghao' + (s + 1)] != null && this.tableData[37]['xinghao' + (s + 1)] != '' ? this.tableData[37]['xinghao' + (s + 1)] : '0') : 'no',//研发组织运营
                                "w41": this.tableData[38]['shifougaishu' + (s + 1)] == true ? (this.tableData[38]['xinghao' + (s + 1)] != null && this.tableData[38]['xinghao' + (s + 1)] != '' ? this.tableData[38]['xinghao' + (s + 1)] : '0') : 'no',//直接费用小计
                                "w42": this.tableData[39]['shifougaishu' + (s + 1)] == true ? (this.tableData[39]['xinghao' + (s + 1)] != null && this.tableData[39]['xinghao' + (s + 1)] != '' ? this.tableData[39]['xinghao' + (s + 1)] : '0') : 'no',//经营贡献
                                "w43": this.tableData[40]['shifougaishu' + (s + 1)] == true ? (this.tableData[40]['xinghao' + (s + 1)] != null && this.tableData[40]['xinghao' + (s + 1)] != '' ? this.tableData[40]['xinghao' + (s + 1)] : '0') : 'no',//经营贡献率
                                "w44": this.tableData[41]['shifougaishu' + (s + 1)] == true ? (this.tableData[41]['xinghao' + (s + 1)] != null && this.tableData[41]['xinghao' + (s + 1)] != '' ? this.tableData[41]['xinghao' + (s + 1)] : '0') : 'no',//销售费用
                                "w45": this.tableData[42]['shifougaishu' + (s + 1)] == true ? (this.tableData[42]['xinghao' + (s + 1)] != null && this.tableData[42]['xinghao' + (s + 1)] != '' ? this.tableData[42]['xinghao' + (s + 1)] : '0') : 'no',//管理费用
                                "w46": this.tableData[43]['shifougaishu' + (s + 1)] == true ? (this.tableData[43]['xinghao' + (s + 1)] != null && this.tableData[43]['xinghao' + (s + 1)] != '' ? this.tableData[43]['xinghao' + (s + 1)] : '0') : 'no',//研发费用
                                "w47": this.tableData[44]['shifougaishu' + (s + 1)] == true ? (this.tableData[44]['xinghao' + (s + 1)] != null && this.tableData[44]['xinghao' + (s + 1)] != '' ? this.tableData[44]['xinghao' + (s + 1)] : '0') : 'no',//平台费用小计
                                "w48": this.tableData[45]['shifougaishu' + (s + 1)] == true ? (this.tableData[45]['xinghao' + (s + 1)] != null && this.tableData[45]['xinghao' + (s + 1)] != '' ? this.tableData[45]['xinghao' + (s + 1)] : '0') : 'no',//利润
                                "w49": this.tableData[46]['shifougaishu' + (s + 1)] == true ? (this.tableData[46]['xinghao' + (s + 1)] != null && this.tableData[46]['xinghao' + (s + 1)] != '' ? this.tableData[46]['xinghao' + (s + 1)] : '0') : 'no',//利润率


								"u28": this.tableData[47]['shifougaishu' + (s + 1)] == true ? (this.tableData[47]['xinghao' + (s + 1)] != null && this.tableData[47]['xinghao' + (s + 1)] != '' ? this.tableData[47]['xinghao' + (s + 1)] : '0') : 'no',//项目所属区域的港杂费率
								"u29": this.tableData[48]['shifougaishu' + (s + 1)] == true ? (this.tableData[48]['xinghao' + (s + 1)] != null && this.tableData[48]['xinghao' + (s + 1)] != '' ? this.tableData[48]['xinghao' + (s + 1)] : '0') : 'no',//项目所属区域的商检认证费率
								"u30": this.tableData[49]['shifougaishu' + (s + 1)] == true ? (this.tableData[49]['xinghao' + (s + 1)] != null && this.tableData[49]['xinghao' + (s + 1)] != '' ? this.tableData[49]['xinghao' + (s + 1)] : '0') : 'no',//1%免费备件费
								"u31": this.tableData[50]['shifougaishu' + (s + 1)] == true ? (this.tableData[50]['xinghao' + (s + 1)] != null && this.tableData[50]['xinghao' + (s + 1)] != '' ? this.tableData[50]['xinghao' + (s + 1)] : '0') : 'no',//售后换机率
								"u36": this.tableData[51]['shifougaishu' + (s + 1)] == true ? (this.tableData[51]['xinghao' + (s + 1)] != null && this.tableData[51]['xinghao' + (s + 1)] != '' ? this.tableData[51]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的其他税费率
								"u37": this.tableData[52]['shifougaishu' + (s + 1)] == true ? (this.tableData[52]['xinghao' + (s + 1)] != null && this.tableData[52]['xinghao' + (s + 1)] != '' ? this.tableData[52]['xinghao' + (s + 1)] : '0') : 'no',//项目所属区域的销售人工费率
								"u38": this.tableData[53]['shifougaishu' + (s + 1)] == true ? (this.tableData[53]['xinghao' + (s + 1)] != null && this.tableData[53]['xinghao' + (s + 1)] != '' ? this.tableData[53]['xinghao' + (s + 1)] : '0') : 'no',//项目所属区域的销售组织运费率
								"u39": this.tableData[54]['shifougaishu' + (s + 1)] == true ? (this.tableData[54]['xinghao' + (s + 1)] != null && this.tableData[54]['xinghao' + (s + 1)] != '' ? this.tableData[54]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的研发人工费率
								"u40": this.tableData[55]['shifougaishu' + (s + 1)] == true ? (this.tableData[55]['xinghao' + (s + 1)] != null && this.tableData[55]['xinghao' + (s + 1)] != '' ? this.tableData[55]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的研发组织运营费率
								"u44": this.tableData[56]['shifougaishu' + (s + 1)] == true ? (this.tableData[56]['xinghao' + (s + 1)] != null && this.tableData[56]['xinghao' + (s + 1)] != '' ? this.tableData[56]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的平台费用-销售费用率
								"u45": this.tableData[57]['shifougaishu' + (s + 1)] == true ? (this.tableData[57]['xinghao' + (s + 1)] != null && this.tableData[57]['xinghao' + (s + 1)] != '' ? this.tableData[57]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的平台费用-管理费用率
								"u46": this.tableData[58]['shifougaishu' + (s + 1)] == true ? (this.tableData[58]['xinghao' + (s + 1)] != null && this.tableData[58]['xinghao' + (s + 1)] != '' ? this.tableData[58]['xinghao' + (s + 1)] : '0') : 'no',//项目所属产品的平台费用-研发费用率

                            },


                        })

                    }

                }

                entity.jsb = jsb;


                console.log(entity, '看看参数怎么样')

                return entity;

            },


            //提交后的回显处理
            tijiaotiaozhuan(q, rd) {

                //若暂存
                if (q == 0) {

                    //成功
                    if (rd.f == true) {

                        this.$msg.msgs("暂存成功")

                    } else {

                        this.$msg.msge(rd.msg)

                    }

                    //若提交
                } else if (q == 1) {

                    //成功
                    if (rd.f == true) {

                        this.$msg.msgs("提交成功")

                        //跳转
                        this.$router.push("/xiangmu/pm")

                    } else {

                        this.$msg.msge(rd.msg)

                    }

                }


            },


            //加载表
            jiazaibiao(rd) {

                //若存在表信息
                if (rd.result) {

                    //写入上头
                    var num = true;

                    this.zonggeshu = 0;

                    //遍历计算结果map
                    for (var r in rd.result) {
						for (var rrr in rd.result[r]) {
							if (
								rrr == 'bizhong'
								|| rrr == 'dingjiaid'
								|| rrr == 'gongjuproname'
								|| rrr == 'lixiangid'
								|| rrr == 'quyubianma2'
								|| rrr == 'shiyongren'
								|| rrr == 'w2'
								|| rrr == 'w1'
								|| rrr == 'validity'
								|| rrr == 'uid'
								|| rrr == 'w3'
								|| rrr == 'w4'
								|| rrr == 'w5'
								|| rrr == 'w6'
								|| rrr == 'w7'
								|| rrr == 'w8'
								|| rrr == 'w9'
								|| rrr == 'w10'
								|| rrr == 'xuanzhongren'
								|| rrr == 'youxiaoqistart'
							) {
								rd.result[r][rrr] = rd.result[r][rrr]
							}else{
								rd.result[r][rrr] = parseFloat(rd.result[r][rrr]) == '0'?'0':parseFloat(rd.result[r][rrr]).toString()
							}
						}
						console.log(r,"///////////////////////////////")
						

                        this.zonggeshu++;

                        //需要写入头
                        if (num) {

                            this.ProMain.youxiaoqi = [rd.result[r].youxiaoqistart == '0' ? "" : rd.result[r].youxiaoqistart, rd.result[r].validity == '0' ? "" : rd.result[r].validity];

                            if (this.shiyongrenuser == null) {

                                this.ProMain.shiyongren = rd.result[r].shiyongren == '0' ? "" : rd.result[r].shiyongren;

                                this.ProMain.xuanzhongren = rd.result[r].xuanzhongren == '0' ? "" : rd.result[r].xuanzhongren;

                            }

                            this.ProMain.projectName = rd.result[r].w1;
                            this.ProMain.quyu = rd.result[r].w2;
                            this.ProMain.des = rd.result[r].quyubianma2;

                            // this.quyukexuan = this.haiwaiquyucesuan;

                            // for (var s in this.haiwaiquyucesuan) {
                            //
                            //     if (this.haiwaiquyucesuan[s].code == rd.result[r].w2) {
                            //
                            //         this.quyukexuan.push({
                            //             label: this.haiwaiquyucesuan[s].name,
                            //             value: this.haiwaiquyucesuan[s].code,
                            //             des: this.haiwaiquyucesuan[s].des,
                            //         })
                            //
                            //     }
                            //
                            // }

                            this.ProMain.bid = rd.result[r].w3;
                            this.ProMain.fukuanfangshi = rd.result[r].w4;
                            this.ProMain.zhangqi = rd.result[r].w5;
                            this.ProMain.repairtype = rd.result[r].w6;
                            this.proid = rd.result[r].u1;

                            //若都有值了
                            if (rd.result[r].w1 && rd.result[r].w2 && rd.result[r].w3 && rd.result[r].w4 && rd.result[r].w5 && rd.result[r].w6) {

                                //就不用再写入了
                                num = false;

                            }

                        }


                        //遍历产品id
                        for (var rr in this.haiwaixiangmuchanpin) {

                            //如果产品id与map的key产品id一致
                            if (r == this.haiwaixiangmuchanpin[rr]) {

                                //遍历产品对应结果键值对
                                for (var rrr in rd.result[r]) {

                                    //遍历表
                                    for (var rrrr in this.tableData) {

                                        //若参数序列对应结果key
                                        if (this.tableData[rrrr].canshuxulie == rrr) {

                                            //对应表第几个产品的值
                                            this.tableData[rrrr]['xinghao' + (parseInt(rr) + 1)] = rd.result[r][rrr];


                                        }

                                        //加载币种 bizhong
                                        if (this.tableData[rrrr].canshuxulie == "w11" && rrr == "bizhong") {

                                            this.tableData[rrrr]['bizhong' + (parseInt(rr) + 1)] = rd.result[r][rrr];

                                            //定价名加上币种
                                            this.tableData[rrrr].coding = '单台一级供价' + rd.result[r][rrr];

                                        }

                                        //单价加上币种
                                        if (this.tableData[rrrr].canshuxulie == "w14" && rrr == "bizhong") {

                                            //单价加上币种
                                            this.tableData[rrrr].coding = '申请单价' + rd.result[r][rrr];

                                        }

                                        //订单金额加上币种
                                        if (this.tableData[rrrr].canshuxulie == "w15" && rrr == "bizhong") {

                                            //订单金额加上币种
                                            this.tableData[rrrr].coding = '订单金额' + rd.result[r][rrr];

                                        }


                                        //------2020-3-4 ---新增

                                        //运费单台加上币种
                                        if (this.tableData[rrrr].canshuxulie == "p1" && rrr == "bizhong") {

                                            this.tableData[rrrr].coding = '运费' + rd.result[r][rrr] + "(单台)";

                                        }

                                        //保费单台加上币种
                                        if (this.tableData[rrrr].canshuxulie == "p2" && rrr == "bizhong") {

                                            this.tableData[rrrr].coding = '保费' + rd.result[r][rrr] + "(单台)";

                                        }

                                        //佣金单台加上币种
                                        if (this.tableData[rrrr].canshuxulie == "p3" && rrr == "bizhong") {

                                            this.tableData[rrrr].coding = '佣金' + rd.result[r][rrr] + "(单台)";

                                        }

                                        //单台售价加上币种
                                        if (this.tableData[rrrr].canshuxulie == "p4" && rrr == "bizhong") {

                                            this.tableData[rrrr].coding = '单台售价' + rd.result[r][rrr];

                                        }

                                        //------------------


                                    }

                                }

                            }

                        }

                    }

                }


                //------------开始加载表合计额率------------
                this.jiazaizonglilv(rd.allrate);


                //------------开始加载表下部否达到盈利目标------------
                if (rd.allrate) {

                    //比较毛利率
                    this.shifoudadaoyinglimubiao(rd.allrate);

                }


                if (this.jisuancishu == 0) {

                    //多存一个tableData
                    this.baocuntable = this.clone(this.tableData);

                }


            },


            //加载总利率
            jiazaizonglilv(q) {

                //存在总额
                if (q) {

                    //订单金额和
                    var w15 = q.w15;

                    //销量和
                    var w13 = q.w13;

                    //成本合计和
                    var w22 = q.w22;

                    //材料毛利和
                    var w23 = q.w23;

                    //订单收入和
                    var w17 = q.w17;

                    //经营贡献和
                    var w42 = q.w42;

                    //利润和
                    var w48 = q.w48;

                    //材料毛利率和
                    var w24 = q.w24;


                    //遍历总额
                    for (var c in q) {

                        //遍历表
                        for (var ccc in this.tableData) {


                            //若参数序列对应结果key
                            if (this.tableData[ccc].hejilvxulie == c) {

                                //对应合计率等于键值对的值
                                this.tableData[ccc].hejiL = q[c];


                            }


                            //若参数序列对应结果key
                            if (this.tableData[ccc].canshuxulie == c) {

                                //对应合计额等于键值对的值
                                this.tableData[ccc].hejiE = q[c];


                                //制造费率  海运费率  保险费率  佣金费率  资金成本费率  中标服务费率  维修基金费率  直接费用小计费率
                                this.divfangfa(c, 'w25', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w26', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w27', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w32', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w33', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w34', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w35', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w41', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w30', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w31', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w36', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w37', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w38', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w39', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w40', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w44', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w45', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w46', ccc, 'hejiL', q[c], w17);
                                this.divfangfa(c, 'w47', ccc, 'hejiL', q[c], w17);


                                //w11单台一级供价  w12折扣率  取平均值  w16汇率
                                this.divfangfa(c, 'w11', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'w12', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'w12', ccc, 'hejiL', q[c], q.savenum);
                                this.divfangfa(c, 'w16', ccc, 'hejiE', q[c], q.savenum);


                                //w14申请单价
                                // this.divfangfa(c, 'w14', ccc, 'hejiE', w15, w13);
                                this.divfangfa(c, 'w14', ccc, 'hejiE', q[c], q.savenum);

                                this.divfangfa(c, 'p1', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'p2', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'p3', ccc, 'hejiE', q[c], q.savenum);
                                this.divfangfa(c, 'p4', ccc, 'hejiE', q[c], q.savenum);


                                //w21单台成本
                                this.divfangfa(c, 'w21', ccc, 'hejiE', w22, w13);

                                //w43经营贡献率
                                this.divfangfa(c, 'w43', ccc, 'hejiE', w42, w17);

                                //w43经营贡献率
                                this.divfangfa(c, 'w43', ccc, 'hejiL', w42, w17);

                                //w42
                                this.divfangfa(c, 'w42', ccc, 'hejiL', w42, w17);


                                //w49利润率
                                this.divfangfa(c, 'w49', ccc, 'hejiE', w48, w17);
                                //w49利润率
                                this.divfangfa(c, 'w49', ccc, 'hejiL', w48, w17);
                                //w48
                                this.divfangfa(c, 'w48', ccc, 'hejiL', w48, w17);


                                //w22
                                this.divfangfa(c, 'w22', ccc, 'hejiL', w22, w17);

                                //w23
                                this.divfangfa(c, 'w23', ccc, 'hejiL', w23, w17);


                                // //w24材料毛利率
                                // this.divfangfa(c, 'w24', ccc, 'hejiE', w23, w17);
                                //
                                // //w24
                                // this.divfangfa(c, 'w24', ccc, 'hejiL', w23, w17);

                                //w24材料毛利率
                                this.divfangfa(c, 'w24', ccc, 'hejiE', w24, this.zonggeshu);

                                //w24
                                this.divfangfa(c, 'w24', ccc, 'hejiL', w24, this.zonggeshu);


                                //w18
                                this.divfangfa(c, 'w18', ccc, 'hejiL', w23, w17);

                                //w19
                                this.divfangfa(c, 'w19', ccc, 'hejiL', w42, w17);

                                //w20
                                this.divfangfa(c, 'w20', ccc, 'hejiL', w48, w17);


                            }


                        }

                    }

                }

            },


            divfangfa(c, c1, ccc, heji, z, z1) {

                if (c == c1) {

                    if (z != '' && z1 != '' && z != 0 && z1 != 0) {


                        this.tableData[ccc][heji] = (new big(parseFloat(z)).div(parseFloat(z1)).toString());


                    } else {

                        this.tableData[ccc][heji] = 0;

                    }

                }


            },


            //深拷贝递归
            clone(o) {
                var temp = {};
                for (var k in o) {
                    if (typeof o[k] == 'object') {
                        temp[k] = this.clone(o[k]);
                    } else {
                        temp[k] = o[k];
                    }
                }
                return temp;
            },

            //清空信息
            qingkongchongzhi() {

                //计算前清空上次的计算过程
                this.rateFormulaRenewVer = {};

                this.xianshinage = 9;

                this.jingyinggongxiangzong = 0;

                this.lirunzong = 0;

                this.zongmaolilvbiao = 0;

                this.zongmaolilv = 0;

                this.haiwaixiangmuchanpin = [];

                this.columndata = [];

                this.biaogechuzhi();

            },


            //海外测算
            haiwaicesuan(q) {


                //必选区域
                if (this.ProMain.quyu != '' && this.ProMain.quyu != null) {

                    //暂存或者提交
                    if ((q == 0 || q == 1) && !(this.ProMain.quyu!=null&&this.ProMain.quyu!='' && this.ProMain.zhangqi!=null&&this.ProMain.zhangqi!='' && this.ProMain.xuanzhongren!=null&&this.ProMain.xuanzhongren!='' && this.ProMain.youxiaoqi && this.ProMain.youxiaoqi[0]!=null&&this.ProMain.youxiaoqi[0]!='' && this.ProMain.youxiaoqi[1]!=null&&this.ProMain.youxiaoqi[1]!='')) {

                        this.$msg.msge("请先填写完整信息")

                    } else {

                        this.qucesuan(q);

                    }

                } else {

                    this.$msg.msge("请选择区域")

                }


            },


            qucesuan(q) {

                this.cesuanfangfa(this.gouzaocesuancanshu(q));

            },


            //测算方法
            cesuanfangfa(q) {

                ss.FormulaHaiwai.getbyhaiwaixiangmu(q).then(rd => {

                    //回显
                    this.tijiaotiaozhuan(q.savestatus, rd)

                    console.log(rd, "看看有没有")

                    this.jiazaijieguoxinxi(rd);

                    //加载表
                    this.jiazaibiao(rd);

                    //若这次测算的保存版本存在
                    if (rd.rateFormulaRenewVer) {

                        //本次计算版本id
                        this.rversion = rd.rateFormulaRenewVer.rversion;

                    }

                })

            },


            //表格初始化
            biaogechuzhi() {

                this.tableData = [{
                    message: '基本信息',
                    coding: '编码',
                    shuoming: '',
                    biaozhun: '',
                    hejiL: '',
                    hejiE: '',
                    xinghao1: '',
                    xinghao2: '',
                    xinghao3: '',
                    xinghao4: '',
                    xinghao5: '',
					xinghao6: '',
					xinghao7: '',
					xinghao8: '',
					xinghao9: '',
					xinghao10: '',
					xinghao11: '',
					xinghao12: '',
					xinghao13: '',
					xinghao14: '',
					xinghao15: '',
                    canshuxulie: 'w7',
                    hejilvxulie: '',
                    flags1: false,
                    flags2: false,
                    flags3: false,
                    flags4: false,
                    flags5: false,
					flags6: false,
					flags7: false,
					flags8: false,
					flags9: false,
					flags10: false,
					flags11: false,
					flags12: false,
					flags13: false,
					flags14: false,
					flags15: false,
//0
                }, {
                    coding: '型号',
                    biaozhun: '',
                    shuoming: '',
                    hejiL: '',
                    hejiE: '',
                    xinghao1: '',
                    xinghao2: '',
                    xinghao3: '',
                    xinghao4: '',
                    xinghao5: '',
					xinghao6: '',
					xinghao7: '',
					xinghao8: '',
					xinghao9: '',
					xinghao10: '',
					xinghao11: '',
					xinghao12: '',
					xinghao13: '',
					xinghao14: '',
					xinghao15: '',
                    canshuxulie: 'w8',
                    hejilvxulie: '',
                    flags1: false,
                    flags2: false,
                    flags3: false,
                    flags4: false,
                    flags5: false,
					flags6: false,
					flags7: false,
					flags8: false,
					flags9: false,
					flags10: false,
					flags11: false,
					flags12: false,
					flags13: false,
					flags14: false,
					flags15: false,
//1
                }, {
                    coding: '产品大类',
                    biaozhun: '',
                    shuoming: '',
                    hejiL: '',
                    hejiE: '',
                    xinghao1: '',
                    xinghao2: '',
                    xinghao3: '',
                    xinghao4: '',
                    xinghao5: '',
					xinghao6: '',
					xinghao7: '',
					xinghao8: '',
					xinghao9: '',
					xinghao10: '',
					xinghao11: '',
					xinghao12: '',
					xinghao13: '',
					xinghao14: '',
					xinghao15: '',
                    canshuxulie: 'w9',
                    hejilvxulie: '',
                    flags1: false,
                    flags2: false,
                    flags3: false,
                    flags4: false,
                    flags5: false,
					flags6: false,
					flags7: false,
					flags8: false,
					flags9: false,
					flags10: false,
					flags11: false,
					flags12: false,
					flags13: false,
					flags14: false,
					flags15: false,
//2
                }, {
                    coding: '产品系列',
                    biaozhun: '',
                    shuoming: '',
                    hejiL: '',
                    hejiE: '',
                    flags1: false,
                    flags2: false,
                    flags3: false,
                    flags4: false,
                    flags5: false,
					flags6: false,
					flags7: false,
					flags8: false,
					flags9: false,
					flags10: false,
					flags11: false,
					flags12: false,
					flags13: false,
					flags14: false,
					flags15: false,
                    xinghao1: '',
                    xinghao2: '',
                    xinghao3: '',
                    xinghao4: '',
                    xinghao5: '',
					xinghao6: '',
					xinghao7: '',
					xinghao8: '',
					xinghao9: '',
					xinghao10: '',
					xinghao11: '',
					xinghao12: '',
					xinghao13: '',
					xinghao14: '',
					xinghao15: '',
                    canshuxulie: 'w10',
                    hejilvxulie: '',
//3
                },
                    {
                        message: '收入',
                        coding: '单台一级供价',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',


                        bizhong1: '',
                        bizhong2: '',
                        bizhong3: '',
                        bizhong4: '',
                        bizhong5: '',
						bizhong6: '',
						bizhong7: '',
						bizhong8: '',
						bizhong9: '',
						bizhong10: '',
						bizhong11: '',
						bizhong12: '',
						bizhong13: '',
						bizhong14: '',
						bizhong15: '',


                        canshuxulie: 'w11',
                        hejilvxulie: '',
//4
                    }, {
                        coding: '折扣率',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w12',
                        hejilvxulie: '',
//5
                    },
                    {
                        coding: '销量',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w13',
                        hejilvxulie: '',
//6
                    },
                    {
                        coding: '申请单价',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'shenqingdanjia',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w14',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        w141: '',
                        w142: '',
                        w143: '',
                        w144: '',
                        w145: '',
						w146: '',
						w147: '',
						w148: '',
						w149: '',
						w150: '',
						w151: '',
						w152: '',
						w153: '',
						w154: '',
						w155: '',

                        hejilvxulie: '',
//7
                    },

                    {
                        coding: '运费(单台)',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'yunfeidantai',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'p1',

                        w141: '',
                        w142: '',
                        w143: '',
                        w144: '',
                        w145: '',
                        w146: '',
                        w147: '',
                        w148: '',
                        w149: '',
                        w150: '',
                        w151: '',
                        w152: '',
                        w153: '',
                        w154: '',
                        w155: '',


                        hejilvxulie: '',
                        //8
                    },

                    {
                        coding: '保费(单台)',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'baofeidantai',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'p2',

                        w141: '',
                        w142: '',
                        w143: '',
                        w144: '',
                        w145: '',
                        w146: '',
                        w147: '',
                        w148: '',
                        w149: '',
                        w150: '',
                        w151: '',
                        w152: '',
                        w153: '',
                        w154: '',
                        w155: '',


                        hejilvxulie: '',
                        //9
                    },


                    {
                        coding: '佣金(单台)',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'yongjindantai',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'p3',

                        w141: '',
                        w142: '',
                        w143: '',
                        w144: '',
                        w145: '',
                        w146: '',
                        w147: '',
                        w148: '',
                        w149: '',
                        w150: '',
                        w151: '',
                        w152: '',
                        w153: '',
                        w154: '',
                        w155: '',


                        hejilvxulie: '',
                        //10
                    },


                    {
                        coding: '单台售价',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'dantaishoujia',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
                        xinghao6: '',
                        xinghao7: '',
                        xinghao8: '',
                        xinghao9: '',
                        xinghao10: '',
                        xinghao11: '',
                        xinghao12: '',
                        xinghao13: '',
                        xinghao14: '',
                        xinghao15: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
                        flags6: false,
                        flags7: false,
                        flags8: false,
                        flags9: false,
                        flags10: false,
                        flags11: false,
                        flags12: false,
                        flags13: false,
                        flags14: false,
                        flags15: false,
                        canshuxulie: 'p4',

                        w141: '',
                        w142: '',
                        w143: '',
                        w144: '',
                        w145: '',
                        w146: '',
                        w147: '',
                        w148: '',
                        w149: '',
                        w150: '',
                        w151: '',
                        w152: '',
                        w153: '',
                        w154: '',
                        w155: '',


                        hejilvxulie: '',
                        //11
                    },

                    {
                        coding: '订单金额',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w15',
                        hejilvxulie: '',
//8
                    },
                    {
                        coding: '汇率',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w16',
                        hejilvxulie: '',
//9
                    },
                    {
                        coding: '订单收入￥',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w17',
                        hejilvxulie: '',
//10
                    },

                    {
                        message: '盈利情况',
                        coding: '材料毛利',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w18',
                        hejilvxulie: '',
//11
                    },
                    {
                        coding: '经营贡献',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w19',
                        hejilvxulie: '',
//12
                    },
                    {
                        coding: '利润',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w20',
                        hejilvxulie: '',
//13
                    },
                    {
                        message: '毛利',
                        coding: '单台成本',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w21',
                        hejilvxulie: '',

                        sunyixianshi1: false,
                        sunyixianshi2: false,
                        sunyixianshi3: false,
                        sunyixianshi4: false,
                        sunyixianshi5: false,
						sunyixianshi6: false,
						sunyixianshi7: false,
						sunyixianshi8: false,
						sunyixianshi9: false,
						sunyixianshi10: false,
						sunyixianshi11: false,
						sunyixianshi12: false,
						sunyixianshi13: false,
						sunyixianshi14: false,
						sunyixianshi15: false,
//14
                    },
                    {
                        coding: '成本合计',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w22',
                        hejilvxulie: '',
//15
                    },
                    {
                        coding: '材料毛利',
                        biaozhun: '',
                        shuoming: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w23',
                        hejilvxulie: '',
//16
                    },
                    {
                        coding: '材料毛利率',
                        biaozhun: '',
                        hejiL: '',
                        shuoming: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w24',
                        hejilvxulie: '',
//17
                    },
                    {
                        message: '直接费用',
                        coding: '制造费用',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w25',
                        hejilvxulie: '',

                        sunyixianshi1: false,
                        sunyixianshi2: false,
                        sunyixianshi3: false,
                        sunyixianshi4: false,
                        sunyixianshi5: false,
						sunyixianshi6: false,
						sunyixianshi7: false,
						sunyixianshi8: false,
						sunyixianshi9: false,
						sunyixianshi10: false,
						sunyixianshi11: false,
						sunyixianshi12: false,
						sunyixianshi13: false,
						sunyixianshi14: false,
						sunyixianshi15: false,
//18
                    },

                    {
                        message: '直接费用',
                        coding: '海运费(CNY)',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w26',
                        hejilvxulie: 'u26',
//19
                    },

                    {
                        coding: '保险费(CNY)',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w27',
                        hejilvxulie: '',
//20
                    },

                    {
                        coding: '港杂费',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w28',
                        hejilvxulie: 'u28',
//21
                    },
                    {
                        coding: '商检认证费',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w29',
                        hejilvxulie: 'u29',
//22
                    },
                    {
                        coding: '售后费用',
                        shuoming: '1%免费备件费',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w30',
                        hejilvxulie: 'u30',
//23
                    },
                    {
                        coding: '售后费用',
                        shuoming: '售后换机',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        u311: '',
                        u312: '',
                        u313: '',
                        u314: '',
                        u315: '',
						u316: '',
						u317: '',
						u318: '',
						u319: '',
						u320: '',
						u321: '',
						u322: '',
						u323: '',
						u324: '',
						u325: '',

                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w31',
                        hejilvxulie: 'u31',

                        sunyixianshi1: false,
                        sunyixianshi2: false,
                        sunyixianshi3: false,
                        sunyixianshi4: false,
                        sunyixianshi5: false,
						sunyixianshi6: false,
						sunyixianshi7: false,
						sunyixianshi8: false,
						sunyixianshi9: false,
						sunyixianshi10: false,
						sunyixianshi11: false,
						sunyixianshi12: false,
						sunyixianshi13: false,
						sunyixianshi14: false,
						sunyixianshi15: false,
//24
                    },
                    {
                        coding: '售后费用',
                        shuoming: '佣金(CNY)',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w32',
                        hejilvxulie: '',
//25
                    },
                    {
                        coding: '资金成本',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w33',
                        hejilvxulie: '',
//26
                    },
                    {
                        coding: '中标服务费(CNY)',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        canshu: 'zhongbiaofuwufei',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w34',
                        marcode1: '',
                        marcode2: '',
                        marcode3: '',
                        marcode4: '',
                        marcode5: '',
						marcode6: '',
						marcode7: '',
						marcode8: '',
						marcode9: '',
						marcode10: '',
						marcode11: '',
						marcode12: '',
						marcode13: '',
						marcode14: '',
						marcode15: '',
                        hejilvxulie: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//27
                    },

                    {
                        coding: '税费',
                        shuoming: '维修基金',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w35',
                        hejilvxulie: '',
//28
                    },
                    {
                        coding: '',
                        shuoming: '其他税费',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w36',
                        hejilvxulie: 'u36',
//29
                    },

                    {
                        coding: '销售费用',
                        shuoming: '销售人工',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w37',
                        hejilvxulie: 'u37',
//30
                    },
                    {
                        coding: '',
                        shuoming: '销售组织运营',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w38',
                        hejilvxulie: 'u38',
//31
                    },
                    {
                        coding: '研发费用',
                        shuoming: '研发人工',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w39',
                        hejilvxulie: 'u39',
//32
                    },
                    {
                        coding: '',
                        shuoming: '研发组织运营',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w40',
                        hejilvxulie: 'u40',
//33
                    },
                    {
                        coding: '直接费用小计',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w41',
                        hejilvxulie: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//34
                    },
                    {
                        message: '经营贡献',
                        coding: '经营贡献',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w42',
                        hejilvxulie: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//35
                    },
                    {
                        coding: '经营贡献率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w43',
                        hejilvxulie: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//36
                    },
                    {
                        message: '平台费用',
                        coding: '销售费用',
                        shuoming: '自产费用率',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w44',
                        hejilvxulie: 'u44',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//37
                    },
                    {
                        coding: '管理费用',
                        shuoming: '全部产品费用率',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w45',
                        hejilvxulie: 'u45',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//38
                    },
                    {
                        coding: '研发费用',
                        shuoming: '自产研发费',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w46',
                        hejilvxulie: 'u46',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//39
                    },
                    {
                        coding: '平台费用小计',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w47',
                        hejilvxulie: 'u47',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//40
                    },
                    {
                        message: '利润',
                        coding: '利润',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w48',
                        hejilvxulie: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//41
                    },
                    {
                        coding: '利润率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'w49',
                        hejilvxulie: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//42
                    },

                    {
                        message: '其他计算参数',
                        coding: '项目所属区域的港杂费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u28',
                        hejilvxulie: 'u28',
//43
                    },
                    {
                        coding: '项目所属区域的商检认证费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u29',
                        hejilvxulie: 'u29',
//44
                    },
                    {
                        coding: '1%免费备件费',
                        shuoming: '物料表取产品组department如果是ND，就是非自产，其他自产  自产产品费率为1%，非自产为0',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u30',
                        hejilvxulie: 'u30',
//45
                    },
                    {
                        coding: '售后换机率',
                        shuoming: '物料表PRODUCT_HIERARCHY截取前三位去损益表查PROD_CODE且ACT_CODE是A02390的    如果平台没有可以手填  小数',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u31',
                        hejilvxulie: 'u31',

//46
                    },


                    {
                        coding: '项目所属产品的其他税费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u36',
                        hejilvxulie: 'u36',
//47
                    },

                    {
                        coding: '项目所属区域的销售人工费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u37',
                        hejilvxulie: 'u37',
//48
                    },
                    {
                        coding: '项目所属区域的销售组织运费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u38',
                        hejilvxulie: 'u38',
//49
                    },
                    {
                        coding: '项目所属产品的研发人工费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u39',
                        hejilvxulie: 'u39',
//50
                    },
                    {
                        coding: '项目所属产品的研发组织运营费率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u40',
                        hejilvxulie: 'u40',
//51
                    },


                    {
                        coding: '项目所属产品的平台费用-销售费用率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u44',
                        hejilvxulie: 'u44',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//52
                    },
                    {
                        coding: '项目所属产品的平台费用-管理费用率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u45',
                        hejilvxulie: 'u45',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//53
                    },
                    {
                        coding: '项目所属产品的平台费用-研发费用率',
                        shuoming: '',
                        biaozhun: '',
                        hejiL: '',
                        hejiE: '',
                        xinghao1: '',
                        xinghao2: '',
                        xinghao3: '',
                        xinghao4: '',
                        xinghao5: '',
						xinghao6: '',
						xinghao7: '',
						xinghao8: '',
						xinghao9: '',
						xinghao10: '',
						xinghao11: '',
						xinghao12: '',
						xinghao13: '',
						xinghao14: '',
						xinghao15: '',
                        canshuxulie: 'u46',
                        hejilvxulie: 'u46',
                        flags1: false,
                        flags2: false,
                        flags3: false,
                        flags4: false,
                        flags5: false,
						flags6: false,
						flags7: false,
						flags8: false,
						flags9: false,
						flags10: false,
						flags11: false,
						flags12: false,
						flags13: false,
						flags14: false,
						flags15: false,
//54
                    },
                ]


                //增加默认属性  财务改数flag
                for (var d in this.tableData) {

                    this.tableData[d].shifougaishu1 = false;
                    this.tableData[d].shifougaishu2 = false;
                    this.tableData[d].shifougaishu3 = false;
                    this.tableData[d].shifougaishu4 = false;
                    this.tableData[d].shifougaishu5 = false;
                    this.tableData[d].shifougaishu6 = false;
                    this.tableData[d].shifougaishu7 = false;
                    this.tableData[d].shifougaishu8 = false;
                    this.tableData[d].shifougaishu9 = false;
                    this.tableData[d].shifougaishu10 = false;
                    this.tableData[d].shifougaishu11 = false;
                    this.tableData[d].shifougaishu12 = false;
                    this.tableData[d].shifougaishu13 = false;
                    this.tableData[d].shifougaishu14 = false;
                    this.tableData[d].shifougaishu15 = false;
                    this.tableData[d].flags1 = false;
                    this.tableData[d].flags2 = false;
                    this.tableData[d].flags3 = false;
                    this.tableData[d].flags4 = false;
                    this.tableData[d].flags5 = false;
                    this.tableData[d].flags6 = false;
                    this.tableData[d].flags7 = false;
                    this.tableData[d].flags8 = false;
                    this.tableData[d].flags9 = false;
                    this.tableData[d].flags10 = false;
                    this.tableData[d].flags11 = false;
                    this.tableData[d].flags12 = false;
                    this.tableData[d].flags13 = false;
                    this.tableData[d].flags14 = false;
                    this.tableData[d].flags15 = false;

                    for (var dd in this.beigaishude) {

                        if (this.beigaishude[dd].canshuxulie == this.tableData[d].canshuxulie && this.beigaishude[dd].flag == true) {

                            this.tableData[d][this.beigaishude[dd].xinghaoji] = true;

                        }

                    }

                }


            },


            //获取海外的项目产品翻页
            haiwaiquery(q) {

                //表格初始化
                this.biaogechuzhi();

                if (q) {

                    //项目id
                    this.ajaxRequest.fileName = q;

                } else if (this.proid) {

                    //项目id
                    this.ajaxRequest.fileName = this.proid;

                }

                //获取项目下所有产品id
                ss.FormulaHaiwai.haiwaixiangmuwuliaoPage(this.ajaxRequest).then(rd => {

                    console.log(rd, '看看返回啥')

                    //加载默认项
                    this.jiazaicolumndata(rd.records);

                })


            },


            //加载默认项
            jiazaicolumndata(chanpinji) {

                //遍历产品，把产品id添加到数组
                for (var c in chanpinji) {

                    //海外产品id数组
                    this.haiwaixiangmuchanpin.push(chanpinji[c].id);

                    //放多型号集合
                    this.duoxinghaocesuan.push(chanpinji[c].productId)

                    //遍历表格
                    for (var d in this.tableData) {

                        //第一行 物料编码
                        if (d == 0) {

                            //对应第几个项目产品的物料编号
                            this.tableData[d]['xinghao' + (parseInt(c) + 1)] = chanpinji[c].productId;

                        }

                    }

                    //加载默认项
                    var cc = {

                        'prop': 'xinghao' + (new big(parseInt(c)).plus(1).toString()),
                        'label': '型号' + (new big(parseInt(c)).plus(1).toString()),
                        'flagsindex': (new big(parseInt(c)).plus(1).toString()),

                    };

                    this.columndata.push(cc);

                }

            },


            mianfeibeijianfeichangetype(value) {

                console.log(value);

            },

            huilvchangetype(value) {

                console.log(value);


            },


            //付款方式选择方法
            fukuanfangshichangetype(value) {

                console.log(value);

                if (value.code == 'TT') {

                    this.ProMain.zhangqi = 0;

                } else {

                    this.ProMain.zhangqi = value.code.split("OA")[1];

                }

            },


            //切换计算版本
            qiehuanbanben() {


                if (this.meiyoubanben == true) {

                    this.$msg.msge("没有测算版本")

                } else {

                    this.shoucijiaohu = true;
                    this.banbenid = '';
                    this.banbenop = [];
                    this.qingkongchongzhi();
                    this.chazhaojisuanguocheng(this.$route.query.id);

                }

            },

            //原始审批版本查看
            caiwuzancunyuanshibanben(){

                this.shoucijiaohu = true;
                this.banbenid = '';
                this.banbenop = [];
                this.qingkongchongzhi();


                //加载对应历史记录版本
                this.zaijiajisuanjilu(this.rversion);

                this.dangqiancaiwuzancun = false;

            },

            //切换计算版本
            qiehuanbanbencaiwuzancun() {

                this.shoucijiaohu = true;
                this.banbenid = '';
                this.banbenop = [];
                this.qingkongchongzhi();

                //查找工具版记录
                this.chazhaocaiwuzancun();
            },


            //取消按钮
            quxiaoanniu() {

                //返回首页
                this.$router.push({path: '/personal/dealCenter'});

            },


            //逻辑删除版本
            handleDelete() {

                if (this.rversion) {

                    var id = {

                        id: this.rversion

                    }

                    ss.FormulaNew.luojishanchu(id).then(rd => {

                        this.$msg.msgs(rd.msg)

                        this.qiehuanbanben();

                    })

                } else {
                    this.$msg.msge("未选择计算版本")
                }

            },


            //返回上页
            fanhuishangye() {

                //跳转
                this.$router.push("/xiangmu/pm");

            },

            //查找财务暂存记录
            chazhaocaiwuzancun() {

                var rversion = {

                    rversion:this.rversion,

                }

                ss.FormulaNew.findcaiwuzancun(rversion).then(rd => {

                    //如果查不到历史记录
                    if (Object.keys(rd.obj).length === 0) {

                        this.showcaiwuzancun = false;

                        //初始化表
                        this.haiwaiquery(q);

                    } else { //查到记录

                        var num = 0;

                        //遍历计算版本map
                        for (var i in rd.obj) {

                            //存计算版本
                            this.caiwuzancunlist.push(rd.obj[i])

                            console.log(i, '反正--------')

                            console.log(rd.obj[i], '---------反正')

                            console.log(i, 'i.rversion')


                                //加载计算版本下拉选
                                var d = {

                                    instid: rd.obj[i].instid,
                                    value: i,
                                    label: '版本 ' + (num + 1) + ' 创建时间:' + this.$util.riQi(rd.obj[i].cdate),

                                }

                                console.log(d, 'dddddd??')

                                //计算版本选项
                                this.banbenop.push(d);


                                num++;

                        }

                        //弹出选框
                        this.showcaiwuzancun = true;

                    }


                })


            },

            //正常加载版本
            zhengchangjiazaibanben(rd) {

                var num = 0;

                //遍历计算版本map
                for (var i in rd.obj) {

                    //存计算版本
                    this.guochenglist.push(rd.obj[i])

                    console.log(i, '反正--------')

                    console.log(rd.obj[i], '---------反正')

                    console.log(i, 'i.rversion')


                    //加载计算版本下拉选
                    var d = {

                        instid: rd.obj[i].instid,
                        value: i,
                        label: '版本 ' + (num + 1) + ' 创建时间:' + this.$util.riQi(rd.obj[i].cdate),

                    }

                    console.log(d, 'dddddd??')

                    //计算版本选项
                    this.banbenop.push(d);

                    num++;

                }

                //弹出选框
                this.refuseDialog = true;

            },

            //查找计算记录
            chazhaojisuanguocheng(q) {

                var pid = {

                    proid: q,
                    neixiaowaixiao: 1,

                }

                ss.FormulaNew.findguochengHaiwai(pid).then(rd => {

                    console.log(rd, 'rdrdrdrdrdrdrdrdrdrdrd')

                    //如果查不到历史记录
                    if (Object.keys(rd.obj).length === 0) {

                        this.refuseDialog = false;

                        //初始化表
                        this.haiwaiquery(q);

                    } else {//查到记录

                        //判断只读
                        this.panduanshifouzhidu(rd);

                        //如果是只读
                        if (this.shifouzhidu == true) {

                            //只读加载版本
                            this.zhidujiazaibanben(rd)

                        } else {

                            //正常加载版本
                            this.zhengchangjiazaibanben(rd);

                        }


                    }


                })


            },


            //只读加载版本
            zhidujiazaibanben(rd) {

                var num = 0;

                //遍历计算版本map
                for (var i in rd.obj) {

                    if (rd.obj[i].status != null && rd.obj[i].status != '' && rd.obj[i].status != 0) {


                        //存计算版本
                        this.guochenglist.push(rd.obj[i])

                        console.log(i, '反正--------')

                        console.log(rd.obj[i], '---------反正')

                        console.log(i, 'i.rversion')


                        //加载计算版本下拉选
                        var d = {

                            instid: rd.obj[i].instid,
                            value: i,
                            label: '版本 ' + (num + 1) + ' 创建时间:' + this.$util.riQi(rd.obj[i].cdate),

                        }

                        console.log(d, 'dddddd??')

                        //计算版本选项
                        this.banbenop.push(d);

                        num++;

                    }


                }

                //弹出选框
                this.refuseDialog = true;


            },


            //正常加载版本
            zhengchangjiazaibanben(rd) {

                var num = 0;

                //遍历计算版本map
                for (var i in rd.obj) {

                    //存计算版本
                    this.guochenglist.push(rd.obj[i])

                    console.log(i, '反正--------')

                    console.log(rd.obj[i], '---------反正')

                    console.log(i, 'i.rversion')


                    //加载计算版本下拉选
                    var d = {

                        instid: rd.obj[i].instid,
                        value: i,
                        label: '版本 ' + (num + 1) + ' 创建时间:' + this.$util.riQi(rd.obj[i].cdate),

                    }

                    console.log(d, 'dddddd??')

                    //计算版本选项
                    this.banbenop.push(d);

                    num++;

                }

                //弹出选框
                this.refuseDialog = true;

            },


            //判断是否只读
            panduanshifouzhidu(q) {

                for (var d in q.obj) {

                    //如果有不是暂存状态的历史版本，说明是只读页面
                    if (q.obj[d].status != null && q.obj[d].status != '' && q.obj[d].status != 0) {

                        this.shifouzhidu = true;

                    }

                }

                console.log(this.shifouzhidu, 'this.shifouzhidu')

            },


            //关闭选择框加载数据
            gettable() {

                //若选了版本
                if (this.banbenid) {

                    //遍历版本选项
                    for (var d in this.banbenop) {

                        //找到对应版本id的项
                        if (this.banbenop[d].value == this.banbenid) {

                            //设置instid
                            this.instid = this.banbenop[d].instid;

                            console.log(this.banbenop[d].instid, '看看')

                        }

                    }

                    console.log(this.rversion, '看看计算版本')

                }

                //如果有版本
                if (this.rversion) {

                    //加载对应历史记录版本
                    this.zaijiajisuanjilu(this.rversion);

                } else {//没版本

                    //初始化
                    this.haiwaiquery();

                }


            },

            //关闭选择框加载数据
            gettablecaiwuzancun() {

                //若选了版本
                if (this.banbenid) {

                    //遍历版本选项
                    for (var d in this.banbenop) {

                        //找到对应版本id的项
                        if (this.banbenop[d].value == this.banbenid) {

                            //设置instid
                            this.instid = this.banbenop[d].instid;

                            console.log(this.banbenop[d].instid, '看看')

                        }

                    }

                    console.log(this.rversion, '看看计算版本')

                }

                //如果有版本
                if (this.rversion) {

                    //加载对应历史记录版本
                    this.zaijiajisuanjilucaiwuzancun(this.rversion);

                }
                else{//没版本

                    //初始化
                    this.haiwaiquery();

                }


            },


            //加载历史财务计算记录
            zaijiajisuanjilucaiwuzancun(q) {

                // //初始化表
                // this.biaogechuzhi();


                var rversion = {

                    rversion: q,

                }

                //加载记录版本
                ss.FormulaNew.getjisuanjilucaiwuzancun(rversion).then(rd => {


                    //当前是财务暂存
                    this.dangqiancaiwuzancun = true;

                    //暂存id
                    this.zancunid = rd.rateFormulaRenewVer.zancunid;

                    //还原版本号
                    this.rversion = rd.rateFormulaRenewVer.rversion;

                    if (rd.rateFormulaRenewVer.status != 0) {

                        this.shifouzhidu = true;

                    }

                    console.log(rd, 'aaa')

                    //判断instid
                    this.panduaninstid(rd.rateFormulaRenewVer);

                    //如果是被驳回的版本
                    if (rd.rateFormulaRenewVer.status == 3) {

                        //不是审批页面
                        this.shenpiyemian = false;

                        //是被驳回的
                        this.beibohui = true;

                        //审批意见
                        this.ProMain.shenpiyijian = rd.rateFormulaRenewVer.shenpijindu.split("_").length == 3 ? rd.rateFormulaRenewVer.shenpijindu.split("_")[2] : "";

                        //显示审批意见
                        this.shenpiyijianshow = true;

                        //查找财务单保存
                        this.chazhaocaiwudanbaocun(rversion);

                    }


                    //加载默认项
                    this.jiazaicolumndata(rd.haiwaixiangmuchanpin);

                    //加载表
                    this.jiazaibiao(rd);

                })

            },


            //加载历史计算记录
            zaijiajisuanjilu(q) {

                //初始化表
                this.biaogechuzhi();

                var rversion = {

                    rversion: q,

                }

                //加载记录版本
                ss.FormulaNew.getjisuanjilu(rversion).then(rd => {

                    //判断instid
                    this.panduaninstid(rd.rateFormulaRenewVer);

                    //如果是被驳回的版本
                    if (rd.rateFormulaRenewVer.status == 3) {

                        //不是审批页面
                        this.shenpiyemian = false;

                        //是被驳回的
                        this.beibohui = true;

                        //审批意见
                        this.ProMain.shenpiyijian = rd.rateFormulaRenewVer.shenpijindu.split("_").length == 3 ? rd.rateFormulaRenewVer.shenpijindu.split("_")[2] : "";

                        //显示审批意见
                        this.shenpiyijianshow = true;

						//查找财务单保存
						this.chazhaocaiwudanbaocun(rversion);

                    }

                    //加载默认项
                    this.jiazaicolumndata(rd.haiwaixiangmuchanpin);

                    //加载表
                    this.jiazaibiao(rd);

                })

            },


            //选没选值
            xuanmeixuanzhi(done) {

                this.$confirm('确认关闭？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
                    .then(_ => {

                        if (!this.banbenid) {
                            this.$msg.msge('请先选择')
                            console.log('请先选择')
                        } else {

                            console.log(this.banbenid, '选中没')

                            done();

                        }

                    })
                    .catch(_ => {

                    });

            },


            //选择，将被选中存起来
            fuzhi() {

                console.log(this.banbenid, '看看选择的对不对')

                //计算版本  选中计算版本
                this.rversion = this.banbenid;

            },


            //提交去申请特价
            tijiaoshenqingtejia() {

                console.log(this.proid, '看看项目号')

                //跳转特价页面
                this.$router.push({path: '/pricenew', query: {proid: this.proid}});

            },


            con(i) {
                console.log(i)
            },
            getit() {
                return 1
            },
            dblclick(v, h, c, d) {
                console.log(v, h, c, d, '???;;??')
            },
            arraySpanMethod({row, column, rowIndex, columnIndex}) {
                if (rowIndex % 3 === 0) {
                    if (columnIndex === 0) {
                        return [1, 4];
                    } else if (columnIndex === 1) {
                        return [0, 0];
                    }
                }
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {

                //不是销售经理
                if (!this.shifouxiaoshoujingli) {
                    if (columnIndex === 0) {
                        if (rowIndex === 0) {
                            return {
                                rowspan: 4,
                                colspan: 1
                            };
                        } else if (rowIndex === 4) {  // 当第7行就为正常的一行；要返回 把1行合并为一列
                            return {
                                rowspan: 11,
                                colspan: 1
                            };
                        } else if (rowIndex === 15) {
                            return {
                                rowspan: 3,
                                colspan: 1
                            }
                        } else if (rowIndex === 18) {
                            return {
                                rowspan: 4,
                                colspan: 1
                            }
                        } else if (rowIndex === 22) {
                            return {
                                rowspan: 17,
                                colspan: 1
                            }
                        } else if (rowIndex === 39) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            }
                        } else if (rowIndex === 41) {
                            return {
                                rowspan: 4,
                                colspan: 1
                            }
                        } else if (rowIndex === 45) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            }
                        }else if (rowIndex === 47) {
                            return {
                                rowspan: 12,
                                colspan: 1
                            }
                        } else {
                            return {
                                rowspan: 0,
                                colspan: 0
                            }
                        }
                    }
                    if (columnIndex === 1) {
                        if (rowIndex === 27) {
                            return {
                                rowspan: 3,
                                colspan: 1
                            };
                        } else if (rowIndex === 28) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 29) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 32) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 33) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 34) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 35) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else if (rowIndex === 36) {
                            return {
                                rowspan: 2,
                                colspan: 1
                            };
                        } else if (rowIndex === 37) {
                            return {
                                rowspan: 0,
                                colspan: 0
                            };
                        } else {
                            return {
                                rowspan: 1,
                                colspan: 1
                            }
                        }
                    }
                    ;


                } else {//销售经理


                    if (columnIndex === 0) {
                        if (rowIndex === 0) {
                            return {
                                rowspan: 4,
                                colspan: 1
                            };
                        } else if (rowIndex === 4) {
                            return {
                                rowspan: 10,
                                colspan: 1
                            };
                        } else if (rowIndex === 23) {
                            return {
                                rowspan: 16,
                                colspan: 1
                            }
                        } else {
                            return {
                                rowspan: 0,
                                colspan: 0
                            }
                        }
                    }

                }

            },


            // //查询翻页
            // query() {
            //
            //     ss.FormulaNew.selectPage(this.q).then(rd => {
            //
            //         if(rd.f!=null&&rd.f==false){
            //             this.$msg.msge(rd.msg)
            //
            //             //跳转
            //             this.$router.push("/personal/dealCenter");
            //
            //         }
            //
            //         this.q.total = rd.total;
            //
            //         this.xiangmuchanpinlist = rd.records;
            //
            //         console.log(this.xiangmuchanpinlist,'看看查到多少项目产品')
            //
            //
            //         if(this.shoucijiaohu){
            //
            //             //默认首次交互
            //             this.getconfigs(0);
            //
            //         }
            //
            //     })
            //
            // },


            // handleFilter() {
            //     this.q.pageNo = 1;
            //     this.query();
            // },


            haiwaihandleFilter() {
                this.q.pageNo = 1;
                this.haiwaiquery();
            },


            //保修期选择方法
            repairchangetype(value) {
                console.log(value);

                if (value) {

                    this.repairtype = value.code;

                }

            },


            // //加载列
            // addbiaotilie(listrd, allrate) {
            //
            //     this.columndata = [];
            //
            //     console.log(listrd)
            //
            //     for (var c in listrd) {
            //
            //         console.log(c)
            //
            //         var cc = {
            //
            //             'prop': 'xinghao' + (new big(parseInt(c)).plus(1).toString()),
            //             'label': '型号' + (new big(parseInt(c)).plus(1).toString()),
            //             'flagsindex': (new big(parseInt(c)).plus(1).toString()),
            //
            //         };
            //
            //
            //         this.columndata.push(cc);
            //
            //
            //     }
            //
            //     this.addshuju(listrd, allrate);
            //
            // },


//             //加载列的数据
//             addshuju(listrd, allrate) {
//
//                 this.alllastlist = [];
//
//                 //单页数据
//                 var csave = {};
//
//                 //遍历每个产品的单表
//                 for (var c in listrd) {
//
//                     //单页数据
//                     csave = {
//
//                         //销量
//                         "productNum": listrd[c].productNum == null ? "" : listrd[c].productNum,
//
//                         //产品编码
//                         "marcode": listrd[c].marcode == null ? "" : listrd[c].marcode,
//
//                         //大类
//                         "typeLevel": listrd[c].typeLevel == null ? "" : listrd[c].typeLevel,
//
//                         //系列
//                         "opeLevel": listrd[c].opeLevel == null ? "" : listrd[c].opeLevel,
//
//                         //不知道是啥
//                         "nonetypeLevel": listrd[c].nonetypeLevel == null ? "" : listrd[c].nonetypeLevel,
//
//                         //产品型号
//                         "productLevel": listrd[c].productLevel == null ? "" : listrd[c].productLevel,
//
//                         //单台一级供价
//                         "onemoney": listrd[c].onemoney == null ? "" : listrd[c].onemoney,
//
//                         //专营商毛利率
//                         "zhuanyingshangmaolilv": listrd[c].zhuanyingshangmaolilv == null ? "" : listrd[c].zhuanyingshangmaolilv,
//
//                         //申请单价含税
//                         "shenqingdanjia": listrd[c].shenqingdanjia == null ? "" : listrd[c].shenqingdanjia,
//
//                         //折扣率
//                         "zhekoulv": listrd[c].zhekoulv == null ? "" : listrd[c].zhekoulv,
//
//                         //订单金额
//                         "dingdanjine": listrd[c].dingdanjine == null ? "" : listrd[c].dingdanjine,
//
//                         //不含税订单收入
//                         "buhanshuishouru": listrd[c].buhanshuishouru == null ? "" : listrd[c].buhanshuishouru,
//
//                         //单台成本
//                         "dantaichengben": listrd[c].dantaichengben == null ? "" : listrd[c].dantaichengben,
//
//                         //制造费用
//                         "zhizaofeiyong": listrd[c].zhizaofeiyong == null ? "" : listrd[c].zhizaofeiyong,
//
//                         //材料的制造费用率
//                         "zhizaofeiyonglv": listrd[c].zhizaofeiyonglv == null ? "" : listrd[c].zhizaofeiyonglv,
//
//                         //单台体积
//                         "wuliufeiyongdanweitiji": listrd[c].wuliufeiyongdanweitiji == null ? "" : listrd[c].wuliufeiyongdanweitiji,
//
//                         //单台安装费
//                         "dantaianzhuangfei": listrd[c].dantaianzhuangfei == null ? "" : listrd[c].dantaianzhuangfei,
//
//                         //维修基金
//                         "weixiujijin": listrd[c].weixiujijin == null ? "" : listrd[c].weixiujijin,
//
//                         //盈亏平衡含税价
//                         "yingkuipingheng": listrd[c].yingkuipingheng == null ? "" : listrd[c].yingkuipingheng,
//
//                         //材料毛利
//                         "yinglicailiaomaoli": listrd[c].yinglicailiaomaoli == null ? "" : listrd[c].yinglicailiaomaoli,
//
//                         //经营贡献
//                         "jingyinggongxian": listrd[c].jingyinggongxian == null ? "" : listrd[c].jingyinggongxian,
//
//                         //盈利 利润
//                         "yinglilirun": listrd[c].yinglilirun == null ? "" : listrd[c].yinglilirun,
//
//                         //毛利 成本合计
//                         "maolichengbenheji": listrd[c].maolichengbenheji == null ? "" : listrd[c].maolichengbenheji,
//
//                         //毛利 毛利
//                         "maolimaoli": listrd[c].maolimaoli == null ? "" : listrd[c].maolimaoli,
//
//                         //毛利 材料毛利率
//                         "maolimaolilv": listrd[c].maolimaolilv == null ? "" : listrd[c].maolimaolilv,
//
//                         //直接费用 物流费用 运费
//                         "wuliufeiyongyunfei": listrd[c].wuliufeiyongyunfei == null ? "" : listrd[c].wuliufeiyongyunfei,
//
//                         //直接费用 维修费  18年到产品实际费用
//                         "zhijiefeiyongweixiufei": listrd[c].zhijiefeiyongweixiufei == null ? "" : listrd[c].zhijiefeiyongweixiufei,
//
//                         //直接费用 备件费 18年到产品实际费用
//                         "zhijiefeiyongbeijianfei": listrd[c].zhijiefeiyongbeijianfei == null ? "" : listrd[c].zhijiefeiyongbeijianfei,
//
//                         //直接费用 退换机 18年到产品实际费用
//                         "zhijiefeiyongtuihuanjifei": listrd[c].zhijiefeiyongtuihuanjifei == null ? "" : listrd[c].zhijiefeiyongtuihuanjifei,
//
//                         //直接费用 退换机 18年到产品实际费用
//                         "zijinchengben": listrd[c].zijinchengben == null ? "" : listrd[c].zijinchengben,
//
//                         //中标服务费
//                         "zhongbiaofuwufei": listrd[c].zhongbiaofuwufei == null ? "" : listrd[c].zhongbiaofuwufei,
//
//                         //直接费用 税费 其他税费
//                         "shuifeiqitashuifei": listrd[c].shuifeiqitashuifei == null ? "" : listrd[c].shuifeiqitashuifei,
//
//                         //销售费用 销售人工
//                         "xiaoshoufeiyongrengong": listrd[c].xiaoshoufeiyongrengong == null ? "" : listrd[c].xiaoshoufeiyongrengong,
//
//                         //销售费用 销售组织运营
//                         "xiaoshouzuzhiyunying": listrd[c].xiaoshouzuzhiyunying == null ? "" : listrd[c].xiaoshouzuzhiyunying,
//
//                         //研发费用 研发人工
//                         "yanfarengong": listrd[c].yanfarengong == null ? "" : listrd[c].yanfarengong,
//
//
//                         //研发费用 研发组织运营
//                         "yanfayunying": listrd[c].yanfayunying == null ? "" : listrd[c].yanfayunying,
//
//                         //直接费用小计
//                         "zhijiefeiyongxiaoji": listrd[c].zhijiefeiyongxiaoji == null ? "" : listrd[c].zhijiefeiyongxiaoji,
//
//                         //经营贡献 经营贡献 经营贡献
//                         "jingyinggongxiansan": listrd[c].jingyinggongxiansan == null ? "" : listrd[c].jingyinggongxiansan,
//
//                         //经营贡献 经营贡献率 经营贡献率
//                         "jingyinggongxianlv": listrd[c].jingyinggongxianlv == null ? "" : listrd[c].jingyinggongxianlv,
//
//                         //平台费用 销售费用 自产费用率
//                         "pingtaixiaoshoufeiyong": listrd[c].pingtaixiaoshoufeiyong == null ? "" : listrd[c].pingtaixiaoshoufeiyong,
//
//                         //平台费用 管理费用 全部产品费用率
//                         "pingtaiguanlifeiyong": listrd[c].pingtaiguanlifeiyong == null ? "" : listrd[c].pingtaiguanlifeiyong,
//
//                         //平台费用 研发费用 自产研发费
//                         "pingtaiyanfafeiyong": listrd[c].pingtaiyanfafeiyong == null ? "" : listrd[c].pingtaiyanfafeiyong,
//
//                         //平台费用 平台费用小计
//                         "pingtaifeiyongxiaoji": listrd[c].pingtaifeiyongxiaoji == null ? "" : listrd[c].pingtaifeiyongxiaoji,
//
//                         //利润 利润  利润
//                         "lirunsan": listrd[c].lirunsan == null ? "" : listrd[c].lirunsan,
//
//                         //利润 利润率  利润率
//                         "lirunlirunlv": listrd[c].lirunlirunlv == null ? "" : listrd[c].lirunlirunlv,
//
//                         //附加成本  赠送耗材、周转机等成本 前台输入
//                         "fujiachengben": listrd[c].fujiachengben == null ? "" : listrd[c].fujiachengben,
//
//                         //终端成交价
//                         "zhongduanchengjiaojia": listrd[c].zhongduanchengjiaojia == null ? "" : listrd[c].zhongduanchengjiaojia,
//
//                         //损益表材料毛利率
//                         "sunyibiaocailiaomaolilv": listrd[c].sunyibiaocailiaomaolilv == null ? "" : listrd[c].sunyibiaocailiaomaolilv,
//
//                     }
//
//                     this.alllastlist.push(csave);
//
//                 }
//
//
//                 this.tableData = [{
//                     message: '基本信息',
//                     coding: '编码',
//                     shuoming: '-',
//                     biaozhun: '-',
//                     hejiL: '-',
//                     hejiE: '-',
//                     xinghao1: this.alllastlist[0].marcode || '',
//                     xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
//                     xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
//                     xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
//                     xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
// 					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
// 					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
// 					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
// 					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
// 					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
// 					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
// 					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
// 					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
// 					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
// 					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
// //0
//                 }, {
//                     coding: '型号',
//                     biaozhun: '-',
//                     shuoming: '-',
//                     hejiL: '-',
//                     hejiE: '-',
//                     xinghao1: this.alllastlist[0].productLevel || '',
//                     xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].productLevel,
//                     xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].productLevel,
//                     xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].productLevel,
//                     xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].productLevel,
// 					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].productLevel,
// 					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].productLevel,
// 					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].productLevel,
// 					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].productLevel,
// 					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].productLevel,
// 					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].productLevel,
// 					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].productLevel,
// 					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].productLevel,
// 					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].productLevel,
// 					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].productLevel,
// //1
//                 }, {
//                     coding: '产品大类',
//                     biaozhun: '-',
//                     shuoming: '-',
//                     hejiL: '-',
//                     hejiE: '-',
//                     xinghao1: this.alllastlist[0].typeLevel || '',
//                     xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].typeLevel,
//                     xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].typeLevel,
//                     xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].typeLevel,
//                     xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].typeLevel,
// 					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].typeLevel,
// 					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].typeLevel,
// 					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].typeLevel,
// 					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].typeLevel,
// 					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].typeLevel,
// 					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].typeLevel,
// 					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].typeLevel,
// 					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].typeLevel,
// 					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].typeLevel,
// 					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].typeLevel,
// //2
//                 }, {
//                     coding: '产品系列',
//                     biaozhun: '-',
//                     shuoming: '-',
//                     hejiL: '-',
//                     hejiE: '-',
//                     xinghao1: this.alllastlist[0].opeLevel || '',
//                     xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].opeLevel,
//                     xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].opeLevel,
//                     xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].opeLevel,
//                     xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].opeLevel,
// 					xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].opeLevel,
// 					xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].opeLevel,
// 					xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].opeLevel,
// 					xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].opeLevel,
// 					xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].opeLevel,
// 					xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].opeLevel,
// 					xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].opeLevel,
// 					xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].opeLevel,
// 					xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].opeLevel,
// 					xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].opeLevel,
// //3
//                 },
//                     {
//                         message: '收入',
//                         coding: '单台一级供价$',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: '-',
//                         hejiE: allrate.onemoney || '',
//                         xinghao1: this.alllastlist[0].onemoney || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].onemoney,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].onemoney,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].onemoney,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].onemoney,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].onemoney,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].onemoney,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].onemoney,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].onemoney,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].onemoney,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].onemoney,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].onemoney,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].onemoney,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].onemoney,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].onemoney,
// //4
//                     }, {
//                         coding: '折扣率',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: allrate.zhekoulv || '',
//                         hejiE: allrate.zhekoulv || '',
//                         xinghao1: this.alllastlist[0].zhekoulv || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhekoulv,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhekoulv,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhekoulv,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhekoulv,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhekoulv,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhekoulv,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhekoulv,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhekoulv,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhekoulv,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhekoulv,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhekoulv,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhekoulv,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhekoulv,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhekoulv,
// //5
//                     },
//                     {
//                         coding: '销量',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: '-',
//                         hejiE: allrate.productNum || '',
//                         xinghao1: this.alllastlist[0].productNum || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].productNum,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].productNum,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].productNum,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].productNum,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].productNum,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].productNum,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].productNum,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].productNum,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].productNum,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].productNum,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].productNum,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].productNum,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].productNum,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].productNum,
// //6
//                     },
//                     {
//                         coding: '申请单价$',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: '-',
//                         hejiE: allrate.shenqingdanjia || '',
//                         canshu: 'shenqingdanjia',
//                         xinghao1: this.alllastlist[0].shenqingdanjia || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].shenqingdanjia,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].shenqingdanjia,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].shenqingdanjia,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].shenqingdanjia,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].shenqingdanjia,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].shenqingdanjia,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].shenqingdanjia,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].shenqingdanjia,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].shenqingdanjia,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].shenqingdanjia,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].shenqingdanjia,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].shenqingdanjia,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].shenqingdanjia,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].shenqingdanjia,
//                         w141: this.alllastlist[0].shenqingdanjia || '',
//                         w142: this.alllastlist[1] == null ? '' : this.alllastlist[1].shenqingdanjia,
//                         w143: this.alllastlist[2] == null ? '' : this.alllastlist[2].shenqingdanjia,
//                         w144: this.alllastlist[3] == null ? '' : this.alllastlist[3].shenqingdanjia,
//                         w145: this.alllastlist[4] == null ? '' : this.alllastlist[4].shenqingdanjia,
// 						w146: this.alllastlist[5] == null ? '' : this.alllastlist[5].shenqingdanjia,
// 						w147: this.alllastlist[6] == null ? '' : this.alllastlist[6].shenqingdanjia,
// 						w148: this.alllastlist[7] == null ? '' : this.alllastlist[7].shenqingdanjia,
// 						w149: this.alllastlist[8] == null ? '' : this.alllastlist[8].shenqingdanjia,
// 						w150: this.alllastlist[9] == null ? '' : this.alllastlist[9].shenqingdanjia,
// 						w151: this.alllastlist[10] == null ? '' : this.alllastlist[10].shenqingdanjia,
// 						w152: this.alllastlist[11] == null ? '' : this.alllastlist[11].shenqingdanjia,
// 						w153: this.alllastlist[12] == null ? '' : this.alllastlist[12].shenqingdanjia,
// 						w154: this.alllastlist[13] == null ? '' : this.alllastlist[13].shenqingdanjia,
// 						w155: this.alllastlist[14] == null ? '' : this.alllastlist[14].shenqingdanjia,
//
// //7
//                     },
//                     {
//                         coding: '订单金额$',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: '-',
//                         hejiE: allrate.dingdanjine || '',
//                         xinghao1: this.alllastlist[0].dingdanjine || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dingdanjine,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dingdanjine,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dingdanjine,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dingdanjine,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dingdanjine,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dingdanjine,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dingdanjine,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dingdanjine,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dingdanjine,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dingdanjine,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dingdanjine,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dingdanjine,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dingdanjine,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dingdanjine,
// //8
//                     },
//                     {
//                         coding: '汇率',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: '-',
//                         hejiE: allrate.dingdanjine || '',
//                         xinghao1: this.alllastlist[0].dingdanjine || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dingdanjine || '',
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dingdanjine || '',
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dingdanjine || '',
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dingdanjine || '',
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dingdanjine || '',
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dingdanjine || '',
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dingdanjine || '',
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dingdanjine || '',
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dingdanjine || '',
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dingdanjine || '',
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dingdanjine || '',
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dingdanjine || '',
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dingdanjine || '',
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dingdanjine || '',
// //9
//                     },
//                     {
//                         coding: '订单收入￥',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: '-',
//                         hejiE: allrate.buhanshuishouru || '',
//                         xinghao1: this.alllastlist[0].buhanshuishouru || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].buhanshuishouru,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].buhanshuishouru,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].buhanshuishouru,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].buhanshuishouru,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].buhanshuishouru,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].buhanshuishouru,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].buhanshuishouru,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].buhanshuishouru,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].buhanshuishouru,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].buhanshuishouru,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].buhanshuishouru,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].buhanshuishouru,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].buhanshuishouru,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].buhanshuishouru,
// //10
//                     },
//
//                     {
//                         message: '盈利情况',
//                         coding: '材料毛利',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.yinglicailiaomaoli || '',
//                         xinghao1: this.alllastlist[0].yinglicailiaomaoli || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yinglicailiaomaoli,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yinglicailiaomaoli,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yinglicailiaomaoli,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yinglicailiaomaoli,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yinglicailiaomaoli,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yinglicailiaomaoli,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yinglicailiaomaoli,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yinglicailiaomaoli,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yinglicailiaomaoli,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yinglicailiaomaoli,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yinglicailiaomaoli,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yinglicailiaomaoli,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yinglicailiaomaoli,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yinglicailiaomaoli,
// //11
//                     },
//                     {
//                         coding: '经营贡献',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: '-',
//                         hejiE: allrate.jingyinggongxian || '',
//                         xinghao1: this.alllastlist[0].jingyinggongxian || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].jingyinggongxian,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].jingyinggongxian,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].jingyinggongxian,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].jingyinggongxian,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].jingyinggongxian,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].jingyinggongxian,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].jingyinggongxian,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].jingyinggongxian,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].jingyinggongxian,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].jingyinggongxian,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].jingyinggongxian,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].jingyinggongxian,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].jingyinggongxian,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].jingyinggongxian,
// //12
//                     },
//                     {
//                         coding: '利润',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: '-',
//                         hejiE: allrate.yinglilirun || '',
//                         xinghao1: this.alllastlist[0].yinglilirun || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yinglilirun,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yinglilirun,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yinglilirun,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yinglilirun,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yinglilirun,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yinglilirun,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yinglilirun,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yinglilirun,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yinglilirun,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yinglilirun,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yinglilirun,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yinglilirun,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yinglilirun,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yinglilirun,
// //13
//                     },
//                     {
//                         message: '毛利',
//                         coding: '单台成本',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.dantaichengben || '',
//                         xinghao1: this.alllastlist[0].dantaichengben || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dantaichengben,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dantaichengben,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dantaichengben,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dantaichengben,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dantaichengben,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dantaichengben,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dantaichengben,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dantaichengben,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dantaichengben,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dantaichengben,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dantaichengben,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dantaichengben,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dantaichengben,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dantaichengben,
// //14
//                     },
//                     {
//                         coding: '成本合计',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: '-',
//                         hejiE: allrate.maolichengbenheji || '',
//                         xinghao1: this.alllastlist[0].maolichengbenheji || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].maolichengbenheji,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].maolichengbenheji,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].maolichengbenheji,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].maolichengbenheji,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].maolichengbenheji,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].maolichengbenheji,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].maolichengbenheji,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].maolichengbenheji,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].maolichengbenheji,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].maolichengbenheji,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].maolichengbenheji,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].maolichengbenheji,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].maolichengbenheji,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].maolichengbenheji,
// //15
//                     },
//                     {
//                         coding: '材料毛利',
//                         biaozhun: '-',
//                         shuoming: '-',
//                         hejiL: '-',
//                         hejiE: allrate.maolimaoli || '',
//                         xinghao1: this.alllastlist[0].maolimaoli || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].maolimaoli,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].maolimaoli,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].maolimaoli,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].maolimaoli,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].maolimaoli,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].maolimaoli,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].maolimaoli,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].maolimaoli,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].maolimaoli,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].maolimaoli,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].maolimaoli,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].maolimaoli,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].maolimaoli,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].maolimaoli,
// //16
//                     },
//                     {
//                         coding: '材料毛利率',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         shuoming: '-',
//                         hejiE: allrate.maolimaolilv || '',
//                         xinghao1: this.alllastlist[0].maolimaolilv || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].maolimaolilv,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].maolimaolilv,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].maolimaolilv,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].maolimaolilv,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].maolimaolilv,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].maolimaolilv,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].maolimaolilv,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].maolimaolilv,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].maolimaolilv,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].maolimaolilv,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].maolimaolilv,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].maolimaolilv,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].maolimaolilv,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].maolimaolilv,
// //17
//                     },
//                     {
//                         message: '直接费用',
//                         coding: '制造费用',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.zhizaofeiyong || '',
//                         xinghao1: this.alllastlist[0].zhizaofeiyong || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhizaofeiyong,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhizaofeiyong,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhizaofeiyong,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhizaofeiyong,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhizaofeiyong,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhizaofeiyong,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhizaofeiyong,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhizaofeiyong,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhizaofeiyong,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhizaofeiyong,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhizaofeiyong,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhizaofeiyong,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhizaofeiyong,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhizaofeiyong,
// //18
//                     },
//
//                     {
//                         coding: '海运费',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.wuliufeiyongdanweitiji || '',
//                         xinghao1: this.alllastlist[0].wuliufeiyongdanweitiji || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].wuliufeiyongdanweitiji,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].wuliufeiyongdanweitiji,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].wuliufeiyongdanweitiji,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].wuliufeiyongdanweitiji,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].wuliufeiyongdanweitiji,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].wuliufeiyongdanweitiji,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].wuliufeiyongdanweitiji,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].wuliufeiyongdanweitiji,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].wuliufeiyongdanweitiji,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].wuliufeiyongdanweitiji,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].wuliufeiyongdanweitiji,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].wuliufeiyongdanweitiji,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].wuliufeiyongdanweitiji,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].wuliufeiyongdanweitiji,
// //19
//                     },
//
//                     {
//                         message: '直接费用',
//                         coding: '保险费',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.wuliufeiyongdanweitiji || '',
//                         xinghao1: this.alllastlist[0].wuliufeiyongdanweitiji || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].wuliufeiyongdanweitiji,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].wuliufeiyongdanweitiji,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].wuliufeiyongdanweitiji,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].wuliufeiyongdanweitiji,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].wuliufeiyongdanweitiji,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].wuliufeiyongdanweitiji,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].wuliufeiyongdanweitiji,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].wuliufeiyongdanweitiji,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].wuliufeiyongdanweitiji,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].wuliufeiyongdanweitiji,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].wuliufeiyongdanweitiji,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].wuliufeiyongdanweitiji,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].wuliufeiyongdanweitiji,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].wuliufeiyongdanweitiji,
// //20
//                     },
//
//                     {
//                         coding: '港杂费',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.dantaianzhuangfei || '',
//                         xinghao1: this.alllastlist[0].dantaianzhuangfei || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dantaianzhuangfei,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dantaianzhuangfei,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dantaianzhuangfei,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dantaianzhuangfei,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dantaianzhuangfei,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dantaianzhuangfei,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dantaianzhuangfei,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dantaianzhuangfei,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dantaianzhuangfei,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dantaianzhuangfei,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dantaianzhuangfei,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dantaianzhuangfei,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dantaianzhuangfei,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dantaianzhuangfei,
// //21
//                     },
//                     {
//                         coding: '商检认证费',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.dantaianzhuangfei || '',
//                         xinghao1: this.alllastlist[0].dantaianzhuangfei || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].dantaianzhuangfei,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].dantaianzhuangfei,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].dantaianzhuangfei,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].dantaianzhuangfei,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].dantaianzhuangfei,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].dantaianzhuangfei,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].dantaianzhuangfei,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].dantaianzhuangfei,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].dantaianzhuangfei,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].dantaianzhuangfei,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].dantaianzhuangfei,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].dantaianzhuangfei,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].dantaianzhuangfei,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].dantaianzhuangfei,
// //22
//                     },
//                     {
//                         coding: '售后费用',
//                         shuoming: '1%免费备件费',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.zhijiefeiyongweixiufei || '',
//                         xinghao1: this.alllastlist[0].zhijiefeiyongweixiufei || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongweixiufei,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongweixiufei,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongweixiufei,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongweixiufei,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongweixiufei,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongweixiufei,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongweixiufei,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongweixiufei,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongweixiufei,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongweixiufei,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongweixiufei,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongweixiufei,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongweixiufei,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongweixiufei,
// //23
//                     },
//                     {
//                         coding: '-',
//                         shuoming: '售后换机',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.zhijiefeiyongbeijianfei || '',
//                         u311: this.alllastlist[0].zhijiefeiyongbeijianfei || '',
//                         u312: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongbeijianfei,
//                         u313: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongbeijianfei,
//                         u314: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongbeijianfei,
//                         u315: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongbeijianfei,
// 						u316: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongbeijianfei,
// 						u317: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongbeijianfei,
// 						u318: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongbeijianfei,
// 						u319: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongbeijianfei,
// 						u320: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongbeijianfei,
// 						u321: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongbeijianfei,
// 						u322: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongbeijianfei,
// 						u323: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongbeijianfei,
// 						u324: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongbeijianfei,
// 						u325: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongbeijianfei,
//
//                         xinghao1: this.alllastlist[0].zhijiefeiyongbeijianfei || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongbeijianfei,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongbeijianfei,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongbeijianfei,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongbeijianfei,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongbeijianfei,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongbeijianfei,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongbeijianfei,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongbeijianfei,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongbeijianfei,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongbeijianfei,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongbeijianfei,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongbeijianfei,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongbeijianfei,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongbeijianfei,
// //24
//                     },
//                     {
//                         coding: '-',
//                         shuoming: '佣金',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.zhijiefeiyongtuihuanjifei || '',
//                         xinghao1: this.alllastlist[0].zhijiefeiyongtuihuanjifei || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongtuihuanjifei,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongtuihuanjifei,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongtuihuanjifei,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongtuihuanjifei,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongtuihuanjifei,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongtuihuanjifei,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongtuihuanjifei,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongtuihuanjifei,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongtuihuanjifei,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongtuihuanjifei,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongtuihuanjifei,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongtuihuanjifei,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongtuihuanjifei,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongtuihuanjifei,
// //25
//                     },
//                     {
//                         coding: '资金成本',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.zijinchengben || '',
//                         xinghao1: this.alllastlist[0].zijinchengben || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zijinchengben,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zijinchengben,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zijinchengben,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zijinchengben,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zijinchengben,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zijinchengben,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zijinchengben,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zijinchengben,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zijinchengben,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zijinchengben,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zijinchengben,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zijinchengben,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zijinchengben,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zijinchengben,
// //26
//                     },
//                     {
//                         coding: '中标服务费',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.zhongbiaofuwufei || '',
//                         canshu: 'zhongbiaofuwufei',
//                         xinghao1: this.alllastlist[0].zhongbiaofuwufei || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhongbiaofuwufei,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhongbiaofuwufei,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhongbiaofuwufei,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhongbiaofuwufei,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhongbiaofuwufei,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhongbiaofuwufei,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhongbiaofuwufei,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhongbiaofuwufei,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhongbiaofuwufei,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhongbiaofuwufei,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhongbiaofuwufei,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhongbiaofuwufei,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhongbiaofuwufei,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhongbiaofuwufei,
//                         marcode1: this.alllastlist[0].marcode || '',
//                         marcode2: this.alllastlist[1] == null ? '' : this.alllastlist[1].marcode,
//                         marcode3: this.alllastlist[2] == null ? '' : this.alllastlist[2].marcode,
//                         marcode4: this.alllastlist[3] == null ? '' : this.alllastlist[3].marcode,
//                         marcode5: this.alllastlist[4] == null ? '' : this.alllastlist[4].marcode,
// 						marcode6: this.alllastlist[5] == null ? '' : this.alllastlist[5].marcode,
// 						marcode7: this.alllastlist[6] == null ? '' : this.alllastlist[6].marcode,
// 						marcode8: this.alllastlist[7] == null ? '' : this.alllastlist[7].marcode,
// 						marcode9: this.alllastlist[8] == null ? '' : this.alllastlist[8].marcode,
// 						marcode10: this.alllastlist[9] == null ? '' : this.alllastlist[9].marcode,
// 						marcode11: this.alllastlist[10] == null ? '' : this.alllastlist[10].marcode,
// 						marcode12: this.alllastlist[11] == null ? '' : this.alllastlist[11].marcode,
// 						marcode13: this.alllastlist[12] == null ? '' : this.alllastlist[12].marcode,
// 						marcode14: this.alllastlist[13] == null ? '' : this.alllastlist[13].marcode,
// 						marcode15: this.alllastlist[14] == null ? '' : this.alllastlist[14].marcode,
// //27
//                     },
//
//                     {
//                         coding: '税费',
//                         shuoming: '维修基金',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.weixiujijin || '',
//                         xinghao1: this.alllastlist[0].weixiujijin || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].weixiujijin,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].weixiujijin,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].weixiujijin,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].weixiujijin,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].weixiujijin,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].weixiujijin,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].weixiujijin,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].weixiujijin,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].weixiujijin,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].weixiujijin,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].weixiujijin,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].weixiujijin,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].weixiujijin,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].weixiujijin,
// //28
//                     },
//                     {
//                         coding: '-',
//                         shuoming: '其他税费',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.shuifeiqitashuifei || '',
//                         xinghao1: this.alllastlist[0].shuifeiqitashuifei || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].shuifeiqitashuifei,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].shuifeiqitashuifei,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].shuifeiqitashuifei,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].shuifeiqitashuifei,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].shuifeiqitashuifei,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].shuifeiqitashuifei,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].shuifeiqitashuifei,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].shuifeiqitashuifei,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].shuifeiqitashuifei,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].shuifeiqitashuifei,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].shuifeiqitashuifei,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].shuifeiqitashuifei,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].shuifeiqitashuifei,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].shuifeiqitashuifei,
// //29
//                     },
//
//                     {
//                         coding: '销售费用',
//                         shuoming: '销售人工',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.xiaoshoufeiyongrengong || '',
//                         xinghao1: this.alllastlist[0].xiaoshoufeiyongrengong || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].xiaoshoufeiyongrengong,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].xiaoshoufeiyongrengong,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].xiaoshoufeiyongrengong,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].xiaoshoufeiyongrengong,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].xiaoshoufeiyongrengong,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].xiaoshoufeiyongrengong,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].xiaoshoufeiyongrengong,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].xiaoshoufeiyongrengong,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].xiaoshoufeiyongrengong,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].xiaoshoufeiyongrengong,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].xiaoshoufeiyongrengong,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].xiaoshoufeiyongrengong,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].xiaoshoufeiyongrengong,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].xiaoshoufeiyongrengong,
// //30
//                     },
//                     {
//                         coding: '-',
//                         shuoming: '销售组织运营',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.xiaoshouzuzhiyunying || '',
//                         xinghao1: this.alllastlist[0].xiaoshouzuzhiyunying || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].xiaoshouzuzhiyunying,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].xiaoshouzuzhiyunying,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].xiaoshouzuzhiyunying,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].xiaoshouzuzhiyunying,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].xiaoshouzuzhiyunying,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].xiaoshouzuzhiyunying,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].xiaoshouzuzhiyunying,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].xiaoshouzuzhiyunying,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].xiaoshouzuzhiyunying,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].xiaoshouzuzhiyunying,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].xiaoshouzuzhiyunying,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].xiaoshouzuzhiyunying,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].xiaoshouzuzhiyunying,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].xiaoshouzuzhiyunying,
// //31
//                     },
//                     {
//                         coding: '研发费用',
//                         shuoming: '研发人工',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.yanfarengong || '',
//                         xinghao1: this.alllastlist[0].yanfarengong || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yanfarengong,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yanfarengong,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yanfarengong,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yanfarengong,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yanfarengong,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yanfarengong,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yanfarengong,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yanfarengong,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yanfarengong,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yanfarengong,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yanfarengong,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yanfarengong,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yanfarengong,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yanfarengong,
// //32
//                     },
//                     {
//                         coding: '-',
//                         shuoming: '研发组织运营',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.yanfayunying || '',
//                         xinghao1: this.alllastlist[0].yanfayunying || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].yanfayunying,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].yanfayunying,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].yanfayunying,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].yanfayunying,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].yanfayunying,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].yanfayunying,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].yanfayunying,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].yanfayunying,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].yanfayunying,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].yanfayunying,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].yanfayunying,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].yanfayunying,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].yanfayunying,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].yanfayunying,
// //33
//                     },
//                     {
//                         coding: '直接费用小计',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.zhijiefeiyongxiaoji || '',
//                         xinghao1: this.alllastlist[0].zhijiefeiyongxiaoji || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].zhijiefeiyongxiaoji,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].zhijiefeiyongxiaoji,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].zhijiefeiyongxiaoji,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].zhijiefeiyongxiaoji,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].zhijiefeiyongxiaoji,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].zhijiefeiyongxiaoji,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].zhijiefeiyongxiaoji,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].zhijiefeiyongxiaoji,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].zhijiefeiyongxiaoji,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].zhijiefeiyongxiaoji,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].zhijiefeiyongxiaoji,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].zhijiefeiyongxiaoji,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].zhijiefeiyongxiaoji,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].zhijiefeiyongxiaoji,
// //34
//                     },
//                     {
//                         message: '经营贡献',
//                         coding: '经营贡献',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.jingyinggongxiansan || '',
//                         xinghao1: this.alllastlist[0].jingyinggongxiansan || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].jingyinggongxiansan,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].jingyinggongxiansan,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].jingyinggongxiansan,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].jingyinggongxiansan,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].jingyinggongxiansan,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].jingyinggongxiansan,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].jingyinggongxiansan,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].jingyinggongxiansan,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].jingyinggongxiansan,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].jingyinggongxiansan,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].jingyinggongxiansan,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].jingyinggongxiansan,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].jingyinggongxiansan,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].jingyinggongxiansan,
// //35
//                     },
//                     {
//                         coding: '经营贡献率',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.jingyinggongxianlv || '',
//                         xinghao1: this.alllastlist[0].jingyinggongxianlv || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].jingyinggongxianlv,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].jingyinggongxianlv,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].jingyinggongxianlv,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].jingyinggongxianlv,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].jingyinggongxianlv,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].jingyinggongxianlv,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].jingyinggongxianlv,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].jingyinggongxianlv,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].jingyinggongxianlv,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].jingyinggongxianlv,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].jingyinggongxianlv,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].jingyinggongxianlv,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].jingyinggongxianlv,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].jingyinggongxianlv,
// //36
//                     },
//                     {
//                         message: '平台费用',
//                         coding: '销售费用',
//                         shuoming: '自产费用率',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.pingtaixiaoshoufeiyong || '',
//                         xinghao1: this.alllastlist[0].pingtaixiaoshoufeiyong || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaixiaoshoufeiyong,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaixiaoshoufeiyong,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaixiaoshoufeiyong,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaixiaoshoufeiyong,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaixiaoshoufeiyong,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaixiaoshoufeiyong,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaixiaoshoufeiyong,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaixiaoshoufeiyong,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaixiaoshoufeiyong,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaixiaoshoufeiyong,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaixiaoshoufeiyong,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaixiaoshoufeiyong,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaixiaoshoufeiyong,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaixiaoshoufeiyong,
// //37
//                     },
//                     {
//                         coding: '管理费用',
//                         shuoming: '全部产品费用率',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.pingtaiguanlifeiyong || '',
//                         xinghao1: this.alllastlist[0].pingtaiguanlifeiyong || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaiguanlifeiyong,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaiguanlifeiyong,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaiguanlifeiyong,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaiguanlifeiyong,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaiguanlifeiyong,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaiguanlifeiyong,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaiguanlifeiyong,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaiguanlifeiyong,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaiguanlifeiyong,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaiguanlifeiyong,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaiguanlifeiyong,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaiguanlifeiyong,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaiguanlifeiyong,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaiguanlifeiyong,
// //38
//                     },
//                     {
//                         coding: '研发费用',
//                         shuoming: '自产研发费',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.pingtaiyanfafeiyong || '',
//                         xinghao1: this.alllastlist[0].pingtaiyanfafeiyong || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaiyanfafeiyong,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaiyanfafeiyong,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaiyanfafeiyong,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaiyanfafeiyong,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaiyanfafeiyong,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaiyanfafeiyong,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaiyanfafeiyong,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaiyanfafeiyong,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaiyanfafeiyong,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaiyanfafeiyong,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaiyanfafeiyong,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaiyanfafeiyong,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaiyanfafeiyong,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaiyanfafeiyong,
// //39
//                     },
//                     {
//                         coding: '平台费用小计',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.pingtaifeiyongxiaoji || '',
//                         xinghao1: this.alllastlist[0].pingtaifeiyongxiaoji || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].pingtaifeiyongxiaoji,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].pingtaifeiyongxiaoji,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].pingtaifeiyongxiaoji,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].pingtaifeiyongxiaoji,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].pingtaifeiyongxiaoji,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].pingtaifeiyongxiaoji,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].pingtaifeiyongxiaoji,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].pingtaifeiyongxiaoji,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].pingtaifeiyongxiaoji,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].pingtaifeiyongxiaoji,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].pingtaifeiyongxiaoji,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].pingtaifeiyongxiaoji,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].pingtaifeiyongxiaoji,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].pingtaifeiyongxiaoji,
// //40
//                     },
//                     {
//                         message: '利润',
//                         coding: '利润',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.lirunsan || '',
//                         xinghao1: this.alllastlist[0].lirunsan || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].lirunsan,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].lirunsan,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].lirunsan,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].lirunsan,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].lirunsan,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].lirunsan,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].lirunsan,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].lirunsan,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].lirunsan,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].lirunsan,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].lirunsan,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].lirunsan,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].lirunsan,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].lirunsan,
// //41
//                     },
//                     {
//                         coding: '利润率',
//                         shuoming: '-',
//                         biaozhun: '-',
//                         hejiL: '-',
//                         hejiE: allrate.lirunlirunlv || '',
//                         xinghao1: this.alllastlist[0].lirunlirunlv || '',
//                         xinghao2: this.alllastlist[1] == null ? '' : this.alllastlist[1].lirunlirunlv,
//                         xinghao3: this.alllastlist[2] == null ? '' : this.alllastlist[2].lirunlirunlv,
//                         xinghao4: this.alllastlist[3] == null ? '' : this.alllastlist[3].lirunlirunlv,
//                         xinghao5: this.alllastlist[4] == null ? '' : this.alllastlist[4].lirunlirunlv,
// 						xinghao6: this.alllastlist[5] == null ? '' : this.alllastlist[5].lirunlirunlv,
// 						xinghao7: this.alllastlist[6] == null ? '' : this.alllastlist[6].lirunlirunlv,
// 						xinghao8: this.alllastlist[7] == null ? '' : this.alllastlist[7].lirunlirunlv,
// 						xinghao9: this.alllastlist[8] == null ? '' : this.alllastlist[8].lirunlirunlv,
// 						xinghao10: this.alllastlist[9] == null ? '' : this.alllastlist[9].lirunlirunlv,
// 						xinghao11: this.alllastlist[10] == null ? '' : this.alllastlist[10].lirunlirunlv,
// 						xinghao12: this.alllastlist[11] == null ? '' : this.alllastlist[11].lirunlirunlv,
// 						xinghao13: this.alllastlist[12] == null ? '' : this.alllastlist[12].lirunlirunlv,
// 						xinghao14: this.alllastlist[13] == null ? '' : this.alllastlist[13].lirunlirunlv,
// 						xinghao15: this.alllastlist[14] == null ? '' : this.alllastlist[14].lirunlirunlv,
// //42
//                     },
//
//                     {
//                         message: '其他计算参数',
//                         coding: '项目所属区域的港杂费率',
//                         shuoming: '',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u28',
//                         hejilvxulie: 'u28',
// //43
//                     },
//                     {
//                         coding: '项目所属区域的商检认证费率',
//                         shuoming: '',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u29',
//                         hejilvxulie: 'u29',
// //44
//                     },
//                     {
//                         coding: '1%免费备件费',
//                         shuoming: '物料表取产品组department如果是ND，就是非自产，其他自产  自产产品费率为1%，非自产为0',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u30',
//                         hejilvxulie: 'u30',
// //45
//                     },
//                     {
//                         coding: '售后换机率',
//                         shuoming: '物料表PRODUCT_HIERARCHY截取前三位去损益表查PROD_CODE且ACT_CODE是A02390的    如果平台没有可以手填  小数',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u31',
//                         hejilvxulie: 'u31',
//
// //46
//                     },
//
//
//                     {
//                         coding: '项目所属产品的其他税费率',
//                         shuoming: '',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u36',
//                         hejilvxulie: 'u36',
// //47
//                     },
//
//                     {
//                         coding: '项目所属区域的销售人工费率',
//                         shuoming: '',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u37',
//                         hejilvxulie: 'u37',
// //48
//                     },
//                     {
//                         coding: '项目所属区域的销售组织运费率',
//                         shuoming: '',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u38',
//                         hejilvxulie: 'u38',
// //49
//                     },
//                     {
//                         coding: '项目所属产品的研发人工费率',
//                         shuoming: '',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u39',
//                         hejilvxulie: 'u39',
// //50
//                     },
//                     {
//                         coding: '项目所属产品的研发组织运营费率',
//                         shuoming: '',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u40',
//                         hejilvxulie: 'u40',
// //51
//                     },
//
//
//                     {
//                         coding: '项目所属产品的平台费用-销售费用率',
//                         shuoming: '',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u44',
//                         hejilvxulie: 'u44',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
// //52
//                     },
//                     {
//                         coding: '项目所属产品的平台费用-管理费用率',
//                         shuoming: '',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u45',
//                         hejilvxulie: 'u45',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
// //53
//                     },
//                     {
//                         coding: '项目所属产品的平台费用-研发费用率',
//                         shuoming: '',
//                         biaozhun: '',
//                         hejiL: '',
//                         hejiE: '',
//                         xinghao1: '',
//                         xinghao2: '',
//                         xinghao3: '',
//                         xinghao4: '',
//                         xinghao5: '',
// 						xinghao6: '',
// 						xinghao7: '',
// 						xinghao8: '',
// 						xinghao9: '',
// 						xinghao10: '',
// 						xinghao11: '',
// 						xinghao12: '',
// 						xinghao13: '',
// 						xinghao14: '',
// 						xinghao15: '',
//                         canshuxulie: 'u46',
//                         hejilvxulie: 'u46',
//                         flags1: false,
//                         flags2: false,
//                         flags3: false,
//                         flags4: false,
//                         flags5: false,
// 						flags6: false,
// 						flags7: false,
// 						flags8: false,
// 						flags9: false,
// 						flags10: false,
// 						flags11: false,
// 						flags12: false,
// 						flags13: false,
// 						flags14: false,
// 						flags15: false,
// //54
//                     },
//
//                 ];
//
//
//                 this.ProMain.zhongduanchengjiaojia = allrate.zhongduanchengjiaojia ? (parseFloat(allrate.zhongduanchengjiaojia).toFixed(2)) : 0;
//                 this.ProMain.zhuanyingshangmaolilv = allrate.zhuanyingshangmaolilv ? (parseFloat(allrate.zhuanyingshangmaolilv).toFixed(2)) : 0;
//
//
//                 if (this.rateFormulaRenewXiangmucanshu != null) {
//
//
//                 }
//
//
//                 // //比较毛利率
//                 // this.shifoudadaoyinglimubiao();
//
//             },


            //判断是否达到盈利目标
            shifoudadaoyinglimubiao(q) {

                //总利润
                this.lirunzong = parseFloat(q.w48);

                //总经营贡献
                this.jingyinggongxiangzong = parseFloat(q.w42);

                //损益表毛利率总额
                this.zongmaolilvbiao = parseFloat(new big(q.sunyibiaocailiaomaolilv).div(this.zonggeshu==0?1:this.zonggeshu).toString());

                //毛利率总额
                var mailizong = parseFloat(new big(q.w24).div(this.zonggeshu==0?1:this.zonggeshu).toString());

                //显示总毛利率%
                this.zongmaolilv = parseInt((mailizong *= 100));

                console.log(this.zongmaolilvbiao, '总毛利率表值')
                console.log(mailizong, '总毛利率值')


                if (this.tableData[46].hejiE) {

                    if (parseFloat(this.tableData[46].hejiE) >= 0.25) {

                        this.xianshinage = 0;

                    } else {

                        this.xianshinage = 1;
                    }

                }


            },


            // jisuan(inputto, q) {
            //
            //
            //     //调接口回调方法
            //     ss.FormulaNew.getAllRateByChanPin(inputto).then(rd => {
            //
            //         console.log(rd, 'aaaaaa???ssss???')
            //
            //         //若是提交的
            //         if (q == 3) {
            //
            //             //如果提交成功且有被驳回版本
            //             if (rd.f == true && this.delrversion) {
            //
            //                 var id = {
            //
            //                     id: this.delrversion
            //
            //                 }
            //
            //                 //把原被驳回版本删除
            //                 ss.FormulaNew.luojishanchu(id).then(rd => {
            //
            //                 })
            //
            //             }
            //
            //             this.$router.push({path: '/personal/dealCenter'});
            //
            //         }
            //
            //         //项目名称
            //         this.ProMain.projectName = rd.result.projectName;
            //
            //         //项目描述
            //         this.ProMain.projectDescription = rd.result.projectDescription;
            //
            //         //下部列表所有计算查询返回信息
            //         var listrd = rd.marnesList;
            //
            //         var allrate = rd.allrate;
            //
            //         //返回计算版本
            //         this.rateFormulaRenewVer = rd.rateFormulaRenewVer;
            //
            //         //从原始记录版本中回调回来的上部内容
            //         this.rateFormulaRenewXiangmucanshu = rd.rateFormulaRenewXiangmucanshu;
            //
            //         //开标时间
            //         this.ProMain.bid = rd.rateFormulaRenewXiangmucanshu.bid != null && rd.rateFormulaRenewXiangmucanshu.bid != '' && rd.rateFormulaRenewXiangmucanshu.bid != '0' && rd.rateFormulaRenewXiangmucanshu.bid != 0 ? this.$util.riQi(rd.rateFormulaRenewXiangmucanshu.bid) : null;
            //
            //         this.ProMain.bidway = rd.rateFormulaRenewXiangmucanshu.bidway;
            //
            //         this.ProMain.repairtype = rd.rateFormulaRenewXiangmucanshu.baoxiuqi;
            //
            //         this.repairtype = rd.rateFormulaRenewXiangmucanshu.baoxiuqi;
            //
            //         this.ProMain.pdpay = rd.rateFormulaRenewXiangmucanshu.f28;
            //
            //         this.ProMain.fdpay = rd.rateFormulaRenewXiangmucanshu.f6;
            //
            //         this.ProMain.mdpay = rd.rateFormulaRenewXiangmucanshu.f27;
            //
            //         this.ProMain.ldpay = rd.rateFormulaRenewXiangmucanshu.f34;
            //
            //         this.ProMain.fdpayday = rd.rateFormulaRenewXiangmucanshu.f23;
            //
            //         this.ProMain.mdpayday = rd.rateFormulaRenewXiangmucanshu.f13;
            //
            //         this.ProMain.ldpayday = rd.rateFormulaRenewXiangmucanshu.f30;
            //
            //
            //         console.log(rd.rateFormulaRenewXiangmucanshu, '看看回调')
            //
            //         //保存计算返回版本id
            //         if (rd.rateFormulaRenewVer.rversion) {
            //             this.fanhuibanbenid = rd.rateFormulaRenewVer.rversion
            //         }
            //
            //         console.log(allrate)
            //
            //         this.allratemap = rd.allrate;
            //
            //
            //         //如果是驳回跳转的
            //         if (rd.shenpijindu) {
            //
            //             //被驳回版本id
            //             this.delrversion = rd.delrversion;
            //
            //             //审批意见
            //             this.ProMain.shenpiyijian = rd.shenpijindu[2] || '';
            //
            //             //显示审批意见
            //             this.shenpiyijianshow = true;
            //
            //         }
            //
            //
            //         //加载列
            //         this.addbiaotilie(listrd, allrate);
            //
            //         this.shoucijiaohu = false;
            //
            //     });
            //
            // },


            // //前后台交互
            // getconfigs(q) {
            //
            //     if ((q == 1 || q == 2 || q == 3) && !(this.ProMain.quyu && this.ProMain.bid && this.ProMain.bidway && this.ProMain.pdpay != null && this.ProMain.fdpay != null && this.ProMain.mdpay != null && this.ProMain.ldpay != null && this.ProMain.fdpayday != null && this.ProMain.mdpayday != null && this.ProMain.ldpayday != null)) {
            //         this.$msg.msge("请先填写完整信息")
            //     } else {
            //         this.jinxingjiaohu(q);
            //     }
            //
            // },


            // //去交互
            // jinxingjiaohu(q) {
            //
            //     //计算前清空上次的计算过程
            //     this.rateFormulaRenewVer = {};
            //
            //     this.xianshinage = 9;
            //
            //     this.jingyinggongxiangzong = 0;
            //
            //     this.lirunzong = 0;
            //
            //     this.zongmaolilvbiao = 0;
            //
            //     this.zongmaolilv = 0;
            //
            //
            //     var s17s14s3s12 = [];
            //
            //     if (!this.shoucijiaohu) {
            //
            //         console.log(this.tableData[0].xinghao1, '看看编码')
            //
            //         for(var c = 1;c<16;c++){
            //
            //             s17s14s3s12.push({
            //
            //                 marcode: this.tableData[0]['xinghao' + c],
            //                 s17: this.tableData[9]['xinghao' + c],
            //                 s14: this.tableData[21]['xinghao' + c],
            //                 s3: this.tableData[30]['xinghao' + c],
            //                 s12: this.tableData[4]['xinghao' + c],
            //
            //             });
            //
            //         }
            //
            //         // s17s14s3s12 = [
            //         //
            //         //     {
            //         //         marcode: this.tableData[0].xinghao1,
            //         //         s17: this.tableData[9].xinghao1,
            //         //         s14: this.tableData[21].xinghao1,
            //         //         s3: this.tableData[30].xinghao1,
            //         //         s12: this.tableData[4].xinghao1,
            //         //
            //         //     },
            //         //
            //         //     {
            //         //         marcode: this.tableData[0].xinghao2,
            //         //         s17: this.tableData[9].xinghao2,
            //         //         s14: this.tableData[21].xinghao2,
            //         //         s3: this.tableData[30].xinghao2,
            //         //         s12: this.tableData[4].xinghao2,
            //         //
            //         //     },
            //         //
            //         //     {
            //         //         marcode: this.tableData[0].xinghao3,
            //         //         s17: this.tableData[9].xinghao3,
            //         //         s14: this.tableData[21].xinghao3,
            //         //         s3: this.tableData[30].xinghao3,
            //         //         s12: this.tableData[4].xinghao3,
            //         //
            //         //     },
            //         //
            //         //     {
            //         //         marcode: this.tableData[0].xinghao4,
            //         //         s17: this.tableData[9].xinghao4,
            //         //         s14: this.tableData[21].xinghao4,
            //         //         s3: this.tableData[30].xinghao4,
            //         //         s12: this.tableData[4].xinghao4,
            //         //
            //         //     },
            //         //
            //         //     {
            //         //         marcode: this.tableData[0].xinghao5,
            //         //         s17: this.tableData[9].xinghao5,
            //         //         s14: this.tableData[21].xinghao5,
            //         //         s3: this.tableData[30].xinghao5,
            //         //         s12: this.tableData[4].xinghao5,
            //         //
            //         //     },
            //         //
            //         // ];
            //
            //         console.log(s17s14s3s12, '看看有没有?????')
            //
            //     }
            //     ;
            //
            //
            //     var jiacan = [];
            //
            //     for (var g in this.xiangmuchanpinlist) {
            //
            //         var dd = {
            //             marcode: this.xiangmuchanpinlist[g].productId,
            //             s17: '0',
            //             s14: '0',
            //             s3: '0',
            //             s12: '0',
            //         };
            //
            //         jiacan.push(dd);
            //
            //     }
            //
            //     console.log(jiacan, '看看jiacan')
            //
            //
            //     //后台接口入参
            //     var inputto = {
            //
            //
            //         "proid": this.proid,
            //
            //         "f28": q == 0 ? "0" : this.ProMain.pdpay + '',
            //         "f6": q == 0 ? "0" : this.ProMain.fdpay + '',
            //         "f23": q == 0 ? "0" : this.ProMain.fdpayday + '',
            //         "f27": q == 0 ? "0" : this.ProMain.mdpay + '',
            //         "f13": q == 0 ? "0" : this.ProMain.mdpayday + '',
            //         "f34": q == 0 ? "0" : this.ProMain.ldpay + '',
            //         "f30": q == 0 ? "0" : this.ProMain.ldpayday + '',
            //         "baoxiuqi": q == 0 ? "0" : this.repairtype + '',
            //
            //         "bid": q == 0 ? "" : this.ProMain.bid,
            //         "bidway": q == 0 ? "zckceshi" : this.ProMain.bidway + '',
            //         "s17s14s3s12": q == 0 ? jiacan : s17s14s3s12,
            //         "savestatus": q == 2 ? 0 : q == 3 ? 1 : null,//2暂存 对应传后台0   3提交 对应传后台1  不是就null
            //         "rversion": this.shoucijiaohu ? this.rversion == null ? null : this.rversion : null,//计算版本
            //         "xid": this.fanhuibanbenid == null ? this.rversion == null ? this.fanhuibanbenid : this.rversion : this.fanhuibanbenid,//之前的保存过的返回计算版本id
            //
            //     };
            //
            //     console.log(this.rversion, '传了没')
            //
            //     this.jisuan(inputto, q);
            //
            //
            // },


            // //翻页
            // gotonextpage() {
            //
            //     for (var j in this.alllastlist) {
            //
            //         if (this.alllastlist.length >= this.value3 && this.value3 == j) {
            //
            //             //   替换数据
            //
            //             this.ProMain.zhuanyingshangmaolilv = this.alllastlist[j].zhuanyingshangmaolilv;
            //
            //
            //             this.tableData = [{
            //                 message: '基本信息',
            //                 coding: '编码',
            //                 shuoming: '-',
            //                 biaozhun: '-',
            //                 hejiL: '-',
            //                 hejiE: '-',
            //                 xinghao: this.alllastlist[j].marcode,
            //                 xiugai: '-',
            //             }, {
            //                 coding: '型号',
            //                 biaozhun: '-',
            //                 shuoming: '-',
            //                 hejiL: '-',
            //                 hejiE: '-',
            //                 xinghao: this.alllastlist[j].productLevel,
            //                 xiugai: '-',
            //             }, {
            //                 coding: '产品大类',
            //                 biaozhun: '-',
            //                 shuoming: '-',
            //                 hejiL: '-',
            //                 hejiE: '-',
            //                 xinghao: this.alllastlist[j].typeLevel,
            //                 xiugai: '-',
            //             }, {
            //                 coding: '产品系列',
            //                 biaozhun: '-',
            //                 shuoming: '-',
            //                 hejiL: '-',
            //                 hejiE: '-',
            //                 xinghao: this.alllastlist[j].opeLevel,
            //                 xiugai: '-',
            //             }, {
            //                 message: '收入',
            //                 coding: '单台一级供价',
            //                 biaozhun: '-',
            //                 shuoming: '-',
            //                 hejiL: '-',
            //                 hejiE: this.alllastlist[j].onemoney,
            //                 xinghao: this.alllastlist[j].onemoney,
            //                 xiugai: '-',
            //             }, {
            //                 coding: '折扣率',
            //                 biaozhun: '-',
            //                 shuoming: '-',
            //                 hejiL: '51%',
            //                 hejiE: '51%',
            //                 xinghao: '51%',
            //                 xiugai: '-',
            //             },
            //                 {
            //                     coding: '销量',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: this.alllastlist[j].productNum,
            //                     xinghao: this.alllastlist[j].productNum,
            //
            //                 },
            //                 {
            //                     coding: '申请单价(含税)',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '26,000',
            //                     xinghao: '26,000',
            //
            //                 },
            //                 {
            //                     coding: '订单金额',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '130,000',
            //                     xinghao: '130,000',
            //
            //                 },
            //                 {
            //                     coding: '不含税订单收入',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '盈亏平衡含税价',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '盈利情况',
            //                     coding: '材料毛利',
            //                     shuoming: '-',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '经营贡献',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '利润',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '毛利',
            //                     coding: '单台成本',
            //                     shuoming: '测算当月BOM成本',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '成本合计',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '毛利',
            //                     biaozhun: '-',
            //                     shuoming: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '材料毛利率',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     shuoming: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '直接费用',
            //                     coding: '制造费用',
            //                     shuoming: '材料的制造费用率',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '物流费用',
            //                     shuoming: '单位体积',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '运费',
            //                     shuoming: '260',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '安装费用',
            //                     shuoming: '单台安装费',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '安装费',
            //                     shuoming: '-',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '维修费',
            //                     shuoming: '18年到产品实际费用',
            //                     biaozhun: '超低温:0.38%',
            //                     hejiL: '0.38',
            //                     hejiE: '437',
            //                     xinghao: '427',
            //
            //                 },
            //                 {
            //                     coding: '备件费',
            //                     shuoming: '18年到产品实际费用',
            //                     biaozhun: '超低温:0.38%-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '退换机',
            //                     shuoming: '18年到产品实际费用',
            //                     biaozhun: '超低温:0.38%',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '资金成本',
            //                     shuoming: '资金成本损失',
            //                     biaozhun: '年度6个点,月度0.5%',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '中标服务费',
            //                     shuoming: '-',
            //                     biaozhun: '-',
            //                     hejiL: '0.0%',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '税费',
            //                     shuoming: '维修基金',
            //                     biaozhun: '12',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '其他税费',
            //                     shuoming: '0.98%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '销售费用',
            //                     shuoming: '销售人工',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '销售组织运营',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '研发费用',
            //                     shuoming: '研发人工',
            //                     biaozhun: '超低温',
            //                     hejiL: '1.12%',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '研发组织运营',
            //                     shuoming: '超低温',
            //                     biaozhun: '0.35%',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '直接费用小计',
            //                     shuoming: '-',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '经营贡献',
            //                     coding: '经营贡献',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '经营贡献率',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '平台费用',
            //                     coding: '销售费用',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '管理费用',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '研发费用',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '平台费用小计',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     message: '利润',
            //                     coding: '利润',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },
            //                 {
            //                     coding: '利润率',
            //                     shuoming: '0.36%',
            //                     biaozhun: '-',
            //                     hejiL: '-',
            //                     hejiE: '115.044',
            //                     xinghao: '115.044',
            //
            //                 },]
            //
            //
            //         }
            //
            //     }
            //
            //
            // },


        }
    }

</script>
<style scoped>
    .h-piece, .h-table {
        margin: 20px;
    }

    .xingxing {
        position: absolute;
        top: 0;
        left: -89px;
        color: red;
        font-size: 0.2rem;
    }

    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }

    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
        background-color: rgb(118, 201, 118);
    }

    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }

    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }

    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }

    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }

    .tip {
        margin-left: 1.6rem;
        color: #b0b0b0;
        font-size: 0.2rem;
        margin-top: 10px;
    }

    .h-bgccc {
        background: #edf5fa;
        border-color: #959595;
        color: #92999e;
    }

    .drags {
        background-color: #ffffff;
        margin-bottom: 30px;
    }
</style>
<style>
	.dddd .h-formbLine .el-form-item__label {
	    width: 23%
	}
	
	.dddd .h-formbLine .el-form-item__content {
	    width: 77%
	}
    .h-enter .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .h-enter .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .h-enter .h-formbLine .el-form-item__content {
        width: 57%;
    }
	.h-enter .h-formbLine .h-elformWrap-1 .el-form-item__label{
		width: 12.5%;
	}
	.h-enter .h-formbLine .h-elformWrap-1 .el-form-item__content{
		width: 86.5%;
	}
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }

    .selectorBox .el-upload-list {
        display: none;
    }


    .drags .el-slider__button-wrapper .el-slider__button {
        background: url(../../../assets/images/drag.png) center/cover;
        border: 0;
        border-radius: 0;
        width: 20px;
        height: 20px;
    }

    .fenyes .h-pagiLabel {
        display: none;
    }

    .fenyes .el-pagination .el-pagination__sizes {
        display: none;
    }
</style>


<style scoped>
    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .product {
        margin-top: 10px;

    }

    .Ptitle {
        margin-top: 30px;
    }

    .resultA {
        border: 1px solid rgb(104, 184, 108);
        background-color: rgb(224, 233, 224);
        color: rgb(126, 216, 130);
    }

    .resultA, .resultB {
        width: 100%;
        height: 150px;
        border-radius: 4px;
        margin: 20px 0;
    }

    .resultB {
        border: 1px solid rgba(233, 161, 52, 0.925);
    }

    h6 > span {
        color: greenyellow;
    }

    h6 > .span {
        color: rgba(233, 161, 52, 0.925);
    }

</style>

<style scoped lang="scss">
    $ft-colorg: #21d16f; //绿色的字
    $ft-coloro: #e79118; //黄色的字
    $bg-colorg: #f6fffa; //绿色的背景色
    $bg-coloro: #fffbf7; //黄色的背景色
    $bg-colorb: #3b77fc; //蓝色
    $bg-colorgrey: #c3c3c3; //灰色
    .yx_progressBar {
        width: 100%;
        border: 1px solid $ft-colorg;
        background-color: $bg-colorg;
        padding: 0.38rem;
        position: relative;

        .yxExtra {
            position: absolute;
            color: $ft-colorg;
            top: 0.3rem;
            font-size: 0.18rem;
            right: 0.3rem;
        }

        .yx_topTip {
            display: flex;
            justify-content: flex-start;
            color: #424441;
            font-size: 0.18rem;

            .leftdes {
                margin-right: 0.75rem;
            }

            .percent {
                color: $ft-colorg;
            }
        }

        .con_progress {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 0.3rem;

            .eve_proout {
                display: flex;
                align-items: center;
                justify-content: flex-start;

                &:last-child .line_pro {
                    display: none;
                }

                .eve_pro {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    position: relative;
                    background-color: $bg-colorgrey;

                    .persons {
                        position: absolute;
                        top: 20px;
                        min-width: 1.8rem;
                        text-align: center;
                        margin-left: -0.75rem;
                        margin-top: 0.04rem;
                        font-size: 0.18rem;
                    }

                    .personsAc {
                        color: $bg-colorb;
                    }
                }


                .line_pro {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorgrey;
                }

                // 激活
                .eve_proAc {
                    background-color: $bg-colorb;
                }

                .line_proAc {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorb;
                }

                .eve_proAcpass {
                    background-color: $bg-colorgrey;
                }

                .line_proAcpass {
                    width: 3rem;
                    height: 4px;
                    background-color: $bg-colorb;
                }
            }

        }
    }

    .yx_progressBarAc {
        border: 1px solid $ft-coloro;
        background-color: $bg-coloro;

        .yxExtra {
            color: $ft-coloro;
        }

        .yx_topTip {
            .percent {
                color: $ft-coloro;
            }
        }
    }


    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .product {
        margin-top: 10px;

    }

    .Ptitle {
        margin-top: 30px;
    }

    .resultA {
        border: 1px solid rgb(104, 184, 108);
        background-color: rgb(224, 233, 224);
        color: rgb(126, 216, 130);
    }

    .resultA, .resultB {
        width: 100%;
        height: 150px;
        border-radius: 4px;
        margin: 20px 0;
    }

    .resultB {
        border: 1px solid rgba(233, 161, 52, 0.925);
    }

    h6 > span {
        color: greenyellow;
    }

    h6 > .span {
        color: rgba(233, 161, 52, 0.925);
    }

    .xia {
        display: flex;
        justify-content: center;
        margin-top: 0.7rem
    }
	.anniu1{
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>


<style>
    .el-table .hidden-row {
        display: none;
    }

    .ljjrange .el-range-editor .el-range-separator {
        line-height: 18px;
    }
	.ljjtableentersix .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtableentersix .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>

